export interface Product {
    id: string;
    title: {
        zh: string;
        en: string;
        ja: string;
        Russian: string;
        Malay: string;
        [key: string]: string;
    };
    category: string;
    desc: {
        zh: string;
        en: string;
        ja: string;
        Russian: string;
        Malay: string;
        [key: string]: string;
    };
    img: string;
    gallery: string[];
    features: {
        zh: string[];
        en: string[];
        ja: string[];
        Russian: string[];
        Malay: string[];
        [key: string]: string[];
    };
    certifications: {
        icon: string;
        name: {
            zh: string;
            en: string;
            ja: string;
            Russian: string;
            Malay: string;
            [key: string]: string;
        };
    }[];
    specifications: {
        name: {
            zh: string;
            en: string;
            ja: string;
            Russian: string;
            Malay: string;
            [key: string]: string;
        };
        value: {
            zh: string;
            en: string;
            ja: string;
            Russian: string;
            Malay: string;
            [key: string]: string;
        };
    }[];
    usageExamples: {
        title: {
            zh: string;
            en: string;
            ja: string;
            Russian: string;
            Malay: string;
            [key: string]: string;
        };
        desc: {
            zh: string;
            en: string;
            ja: string;
            Russian: string;
            Malay: string;
            [key: string]: string;
        };
        img: string;
    }[];
    relatedProducts: string[];
}

export interface Advantage {
    icon: string;
    title: {
        zh: string;
        en: string;
        ja: string;
        Russian: string;
        Malay: string;
        [key: string]: string;
    };
    desc: {
        zh: string;
        en: string;
        ja: string;
        Russian: string;
        Malay: string;
        [key: string]: string;
    };
}

export interface Application {
    img: string;
    title: {
        zh: string;
        en: string;
        ja: string;
        Russian: string;
        Malay: string;
        [key: string]: string;
    };
    desc: {
        zh: string;
        en: string;
        ja: string;
        Russian: string;
        Malay: string;
        [key: string]: string;
    };
}

export const tabs : {
    key: string;
    label: {
        zh: string;
        en: string;
        ja: string;
        Russian: string;
        Malay: string;
        [key: string]: string;
    };
}[] = [
    { key: 'all', label: { zh: '全部产品', en: 'All Products', ja: 'すべての製品', Russian: 'すべての製品', Malay: 'すべての製品' } },
    { key: 'pulp', label: { zh: '原生竹浆', en: 'Virgin Bamboo Pulp', ja: 'バージンバンブーパルプ', Russian: 'すべての製品', Malay: 'すべての製品' } },
    { key: 'packaging', label: { zh: '原生竹浆包装用纸', en: 'Virgin Bamboo Packaging Paper', ja: 'バージンバンブー包装紙' , Russian: 'すべての製品', Malay: 'すべての製品'} },
    { key: 'cultural', label: { zh: '原生竹浆文化用纸', en: 'Virgin Bamboo Cultural Paper', ja: 'バージンバンブー文化用紙' , Russian: 'すべての製品', Malay: 'すべての製品'} },
    { key: 'rawpaper', label: { zh: '原生竹浆生活原纸', en: 'Virgin Bamboo Raw Paper', ja: 'バージンバンブー生活用原紙' , Russian: 'すべての製品', Malay: 'すべての製品'} },
    { key: 'finishedpaper', label: { zh: '原生竹浆生活成品纸', en: 'Virgin Bamboo Finished Paper', ja: 'バージンバンブー生活用完成紙', Russian: 'すべての製品', Malay: 'すべての製品' } },
    { key: 'fiber', label: { zh: '纤维材料', en: 'Fiber Materials', ja: '繊維材料', Russian: 'すべての製品', Malay: 'すべての製品' } },
];

export const products: Product[] = [
    {
        id: 'pulp-001',
        title: {
            zh: '本色竹浆板',
            en: 'Natural Color Bamboo Pulp Board',
            ja: 'ナチュラルカラーバンブーパルプボード',
            Russian: 'ナチュラルカラーバンブーパルプボード',
            Malay: 'ナチュラルカラーバンブーパルプボード'
        },
        category: 'pulp',
        desc: {
            zh: '精选优质竹种、提取最好的竹纤维',
            en: 'Selected premium bamboo species, extracting the finest bamboo fibers',
            ja: '最高のバンブーファイバーを抽出するために、優れたバンブー種を選択しました。',
            Russian: 'ナチュラルカラーバンブーパルプボード',
            Malay: 'ナチュラルカラーバンブーパルプボード'
        },
        img: '/images/mainProduction/YuanSeZhuJiangSuoLve.png',
        gallery: [
            // '/images/mainProduction/YuanSeZhuJiangSuoLve.png',
            // '/images/mainProduction/YuanSeZhuJiangSuoLve.png',
            // '/images/mainProduction/YuanSeZhuJiangSuoLve.png',
            '/images/mainProduction/YuanSeZhuJiangSuoLve.png'
        ],
        features: {
            zh: [
                '优质竹种',
                '纤维长，宽度粗',
                '综合强度好',
                '环保可降解'
            ],
            en: [
                '100% Virgin Bamboo Pulp',
                'Premium Bamboo Species',
                'High Purity',
                'Eco-friendly and Biodegradable'
            ],
            ja: [
                '100%バージンバンブーパルプ',
                'プレミアムバンブースペシーズ',
                '高純度',
                'エコフレンドリーでありがとう'
            ],
            Russian: [
                '100%バージンバンブーパルプ',
                'プレミアムバンブースペシーズ',
                '高純度',
                'エコフレンドリーでありがとう'
            ],
            Malay: [
                '100%バージンバンブーパルプ',
                'プレミアムバンブースペシーズ',
                '高純度',
                'エコフレンドリーでありがとう'
            ]
        },
        certifications: [
            // {
            //     icon: 'fa-certificate',
            //     name: {
            //         zh: 'ISO9001认证',
            //         en: 'ISO9001 Certification',
            //         ja: 'ISO9001認証'
            //     }
            // },
            // {
            //     icon: 'fa-leaf',
            //     name: {
            //         zh: 'FSC认证',
            //         en: 'FSC Certification',
            //         ja: 'FSC認証'
            //     }
            // }
        ],
        specifications: [
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '标准规格',
                    en: 'Standard Specification',
                    ja: '標準仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '颜色',
                    en: 'Purity',
                    ja: '純度',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '本色',
                    en: '99.9%',
                    ja: '99.9%',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '造纸原料',
                    en: 'Paper Making Material',
                    ja: '紙製造原料',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '卫生纸产品加工领域',
                    en: 'Used for producing various paper products',
                    ja: '様々な紙製品を作るために使用されます',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ZaoZhiLingYu.png'
            },
            {
                title: {
                    zh: '纸浆模塑',
                    en: 'Paper Making Material',
                    ja: '紙製造原料',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '纸浆模塑产品加工领域',
                    en: 'Used for producing various paper products',
                    ja: '様々な紙製品を作るために使用されます',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ZhiJiangMoSu.png'
            },
            {
                title: {
                    zh: '特种纸加工',
                    en: 'Paper Making Material',
                    ja: '紙製造原料',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '特种纸等产品加工领域',
                    en: 'Used for producing various paper products',
                    ja: '様々な紙製品を作るために使用されます',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/TeZhongZhiJiaGong.png'
            }
        ],
        relatedProducts: ['pulp-002', 'packaging-001', 'packaging-002']
    },
    {
        id: 'pulp-002',
        title: {
            zh: '漂白竹浆板',
            en: 'Bleached Bamboo Pulp Board',
            ja: 'ホワイトバンブーパルプボード',
            Russian: '仕様',
            Malay: '仕様'
        },
        category: 'pulp',
        desc: {
            zh: '精选优质竹种、提取最好的竹纤维',
            en: 'Selected premium bamboo species, extracting the finest bamboo fibers',
            ja: '最高のバンブーファイバーを抽出するために、優れたバンブー種を選択しました。',
            Russian: '仕様',
            Malay: '仕様'
        },
        img: '/images/mainProduction/BaiSeZhuJiangSuoLve.png',
        gallery: [
            // '/images/mainProduction/BaiSeZhuJiangSuoLve.png',
            // '/images/mainProduction/BaiSeZhuJiangSuoLve.png',
            // '/images/mainProduction/BaiSeZhuJiangSuoLve.png',
            '/images/mainProduction/BaiSeZhuJiangSuoLve.png'
        ],
        features: {
            zh: [
                '优质竹种',
                '纤维长，宽度粗',
                '综合强度好',
                '环保可降解'
            ],
            en: [
                '100% Virgin Bamboo Pulp',
                'Premium Bamboo Species',
                'High Purity',
                'Eco-friendly and Biodegradable'
            ],
            ja: [
                '100%バージンバンブーパルプ',
                'プレミアムバンブースペシーズ',
                '高純度',
                'エコフレンドリーでありがとう'
            ],
            Russian: [
                '100%バージンバンブーパルプ',
                'プレミアムバンブースペシーズ',
                '高純度',
                'エコフレンドリーでありがとう'
            ],
            Malay: [
                '100%バージンバンブーパルプ',
                'プレミアムバンブースペシーズ',
                '高純度',
                'エコフレンドリーでありがとう'
            ]
        },
        certifications: [
            // {
            //     icon: 'fa-certificate',
            //     name: {
            //         zh: 'ISO9001认证',
            //         en: 'ISO9001 Certification',
            //         ja: 'ISO9001認証'
            //     }
            // },
            // {
            //     icon: 'fa-leaf',
            //     name: {
            //         zh: 'FSC认证',
            //         en: 'FSC Certification',
            //         ja: 'FSC認証'
            //     }
            // }
        ],
        specifications: [
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '标准规格',
                    en: 'Standard Specification',
                    ja: '標準仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '颜色',
                    en: 'Purity',
                    ja: '純度',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '白色',
                    en: '99.9%',
                    ja: '99.9%',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '造纸原料',
                    en: 'Paper Making Material',
                    ja: '紙製造原料',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '卫生纸产品加工领域',
                    en: 'Used for producing various paper products',
                    ja: '様々な紙製品を作るために使用されます',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ZaoZhiLingYu.png'
            },
            {
                title: {
                    zh: '纸浆模塑',
                    en: 'Paper Making Material',
                    ja: '紙製造原料',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '纸浆模塑产品加工领域',
                    en: 'Used for producing various paper products',
                    ja: '様々な紙製品を作るために使用されます',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ZhiJiangMoSu.png'
            },
            {
                title: {
                    zh: '特种纸加工',
                    en: 'Paper Making Material',
                    ja: '紙製造原料',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '特种纸等产品加工领域',
                    en: 'Used for producing various paper products',
                    ja: '様々な紙製品を作るために使用されます',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/TeZhongZhiJiaGong.png'
            }
        ],
        relatedProducts: ['pulp-001', 'packaging-001', 'packaging-002']
    },
    {
        id: 'packaging-001',
        title: {
            zh: '漂白全竹浆纸',
            en: 'Bamboo Pulp Food Packaging Paper',
            ja: 'バンブーパルプフードパッケージペーパー',
            Russian: '仕様',
            Malay: '仕様'
        },
        category: 'packaging',
        desc: {
            zh: '加工产品易成型、得率高、报废少',
            en: 'Easy to form, high yield, low waste rate',
            ja: '加工製品は簡単に形成でき、高い収率と低い廃棄率があります。',
            Russian: '仕様',
            Malay: '仕様'
        },
        img: '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
        gallery: [
            // '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
            // '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
            // '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
            '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png'
        ],
        features: {
            zh: [
                '无荧光增白剂',
                '未涂布、未淋膜，厚度均匀',
                '具有良好的边渗透性能',
                '无异味，符合国家食品安全要求'
            ],
            en: [
                'Easy to Form',
                'High Yield',
                'Low Waste Rate',
                'Eco-friendly and Biodegradable'
            ],
            ja: [
                '簡単に形成できる',
                '高い収率',
                '低い廃棄率',
                'エコフレンドリーでありがとう'
            ],
            Russian: [
                '簡単に形成できる',
                '高い収率',
                '低い廃棄率',
                'エコフレンドリーでありがとう'
            ],
            Malay: [
                '簡単に形成できる',
                '高い収率',
                '低い廃棄率',
                'エコフレンドリーでありがとう'
            ]
        },
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'QS认证',
                    en: 'ISO9001 Certification',
                    ja: 'ISO9001認証',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                icon: 'fa-shield-alt',
                name: {
                    zh: 'FSC认证',
                    en: 'Food Grade Certification',
                    ja: '食品レベル認証',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '190/320/350 g/㎡',
                    en: 'Standard Specification',
                    ja: '標準仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '克重',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '根据需求定制',
                    en: 'Customized according to requirements',
                    ja: '要件に基づいてカスタマイズされます',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '纯度',
                    en: 'Purity',
                    ja: '純度',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '100%原生竹浆',
                    en: '100%',
                    ja: '100%',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '指导价',
                    en: 'Purity',
                    ja: '純度',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '5100元/吨',
                    en: '100%',
                    ja: '100%',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '纸杯加工',
                    en: 'Food Packaging',
                    ja: 'フードパッケージ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '用于各类纸杯生产加工。',
                    en: 'Suitable for various food packaging',
                    ja: '様々な食品パッケージに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ZhiBeiShengChan.png'
            },
            {
                title: {
                    zh: '纸碗加工',
                    en: 'Food Packaging',
                    ja: 'フードパッケージ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '用于各类纸碗、纸餐具加工生产。',
                    en: 'Suitable for various food packaging',
                    ja: '様々な食品パッケージに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ZhiWanJiaGong.png'
            },
            {
                title: {
                    zh: '快餐桶加工',
                    en: 'Food Packaging',
                    ja: 'フードパッケージ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '用于各类纸桶、纸盒加工生产。',
                    en: 'Suitable for various food packaging',
                    ja: '様々な食品パッケージに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ZhiTongShengChan.png'
            }
        ],
        relatedProducts: ['packaging-002', 'packaging-003', 'packaging-004']
    },
    {
        id: 'packaging-002',
        title: {
            zh: '高松纸',
            en: 'Bamboo Pulp Food Packaging Paper',
            ja: 'バンブーパルプフードパッケージペーパー',
            Russian: '仕様',
            Malay: '仕様'
        },
        category: 'packaging',
        desc: {
            zh: '加工产品易成型、得率高、报废少',
            en: 'Easy to form, high yield, low waste rate',
            ja: '加工製品は簡単に形成でき、高い収率と低い廃棄率があります。',
            Russian: '仕様',
            Malay: '仕様'
        },
        img: '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
        gallery: [
            // '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
            // '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
            // '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
            '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png'
        ],
        features: {
            zh: [
                '无荧光增白剂',
                '未涂布、未淋膜，厚度均匀',
                '具有良好的边渗透性能',
                '超高松厚度、高挺度'
            ],
            en: [
                'Easy to Form',
                'High Yield',
                'Low Waste Rate',
                'Eco-friendly and Biodegradable'
            ],
            ja: [
                '簡単に形成できる',
                '高い収率',
                '低い廃棄率',
                'エコフレンドリーでありがとう'
            ],
            Russian: [
                '簡単に形成できる',
                '高い収率',
                '低い廃棄率',
                'エコフレンドリーでありがとう'
            ],
            Malay: [
                '簡単に形成できる',
                '高い収率',
                '低い廃棄率',
                'エコフレンドリーでありがとう'
            ]
        },
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'QS认证',
                    en: 'ISO9001 Certification',
                    ja: 'ISO9001認証',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                icon: 'fa-shield-alt',
                name: {
                    zh: '国家食品安全要求',
                    en: 'Food Grade Certification',
                    ja: '食品レベル認証',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '150~300 g/㎡',
                    en: 'Standard Specification',
                    ja: '標準仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '克重',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '根据需求定制',
                    en: 'Customized according to requirements',
                    ja: '要件に基づいてカスタマイズされます',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '成分',
                    en: 'Purity',
                    ja: '純度',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '原生竹浆、原生木浆',
                    en: '100%',
                    ja: '100%',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '指导价',
                    en: 'Purity',
                    ja: '純度',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '5100元/吨',
                    en: '100%',
                    ja: '100%',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '纸杯加工',
                    en: 'Food Packaging',
                    ja: 'フードパッケージ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '用于各类纸杯生产加工。',
                    en: 'Suitable for various food packaging',
                    ja: '様々な食品パッケージに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ZhiBeiShengChan.png'
            },
            {
                title: {
                    zh: '纸碗加工',
                    en: 'Food Packaging',
                    ja: 'フードパッケージ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '用于各类纸碗、纸餐具加工生产。',
                    en: 'Suitable for various food packaging',
                    ja: '様々な食品パッケージに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ZhiWanJiaGong.png'
            },
            {
                title: {
                    zh: '快餐桶加工',
                    en: 'Food Packaging',
                    ja: 'フードパッケージ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '用于各类纸桶、纸盒加工生产。',
                    en: 'Suitable for various food packaging',
                    ja: '様々な食品パッケージに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ZhiTongShengChan.png'
            }
        ],
        relatedProducts: ['packaging-001', 'packaging-003', 'packaging-004']
    },
    {
        id: 'packaging-003',
        title: {
            zh: '高档中松纸',
            en: 'Bamboo Pulp Food Packaging Paper',
            ja: 'バンブーパルプフードパッケージペーパー',
            Russian: '仕様',
            Malay: '仕様'
        },
        category: 'packaging',
        desc: {
            zh: '加工产品易成型、得率高、报废少',
            en: 'Easy to form, high yield, low waste rate',
            ja: '加工製品は簡単に形成でき、高い収率と低い廃棄率があります。',
            Russian: '仕様',
            Malay: '仕様'
        },
        img: '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
        gallery: [
            // '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
            // '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
            // '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
            '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png'
        ],
        features: {
            zh: [
                '无荧光增白剂',
                '未涂布、未淋膜，厚度均匀',
                '无异味，具有良好的边渗透性能',
                '高松厚度、高挺度'
            ],
            en: [
                'Easy to Form',
                'High Yield',
                'Low Waste Rate',
                'Eco-friendly and Biodegradable'
            ],
            ja: [
                '簡単に形成できる',
                '高い収率',
                '低い廃棄率',
                'エコフレンドリーでありがとう'
            ],
            Russian: [
                '簡単に形成できる',
                '高い収率',
                '低い廃棄率',
                'エコフレンドリーでありがとう'
            ],
            Malay: [
                '簡単に形成できる',
                '高い収率',
                '低い廃棄率',
                'エコフレンドリーでありがとう'
            ]
        },
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'QS认证',
                    en: 'ISO9001 Certification',
                    ja: 'ISO9001認証',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                icon: 'fa-shield-alt',
                name: {
                    zh: 'FSC认证',
                    en: 'Food Grade Certification',
                    ja: '食品レベル認証',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '150~350 g/㎡',
                    en: 'Standard Specification',
                    ja: '標準仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '克重',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '根据需求定制',
                    en: 'Customized according to requirements',
                    ja: '要件に基づいてカスタマイズされます',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '成分',
                    en: 'Purity',
                    ja: '純度',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '原生竹浆、原生木浆',
                    en: '100%',
                    ja: '100%',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '指导价',
                    en: 'Purity',
                    ja: '純度',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '5100元/吨',
                    en: '100%',
                    ja: '100%',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '纸杯加工',
                    en: 'Food Packaging',
                    ja: 'フードパッケージ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '用于各类纸杯生产加工。',
                    en: 'Suitable for various food packaging',
                    ja: '様々な食品パッケージに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ZhiBeiShengChan.png'
            },
            {
                title: {
                    zh: '纸碗加工',
                    en: 'Food Packaging',
                    ja: 'フードパッケージ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '用于各类纸碗、纸餐具加工生产。',
                    en: 'Suitable for various food packaging',
                    ja: '様々な食品パッケージに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ZhiWanJiaGong.png'
            },
            {
                title: {
                    zh: '快餐桶加工',
                    en: 'Food Packaging',
                    ja: 'フードパッケージ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '用于各类纸桶、纸盒加工生产。',
                    en: 'Suitable for various food packaging',
                    ja: '様々な食品パッケージに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ZhiTongShengChan.png'
            }
        ],
        relatedProducts: ['packaging-001', 'packaging-002', 'packaging-004']
    },
    {
        id: 'packaging-004',
        title: {
            zh: '普松纸',
            en: 'Bamboo Pulp Food Packaging Paper',
            ja: 'バンブーパルプフードパッケージペーパー',
            Russian: '仕様',
            Malay: '仕様'
        },
        category: 'packaging',
        desc: {
            zh: '加工产品易成型、得率高、报废少',
            en: 'Easy to form, high yield, low waste rate',
            ja: '加工製品は簡単に形成でき、高い収率と低い廃棄率があります。',
            Russian: '仕様',
            Malay: '仕様'
        },
        img: '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
        gallery: [
            // '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
            // '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
            // '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
            '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png'
        ],
        features: {
            zh: [
                '无荧光增白剂',
                '未涂布、未淋膜，厚度均匀',
                '无异味',
                '具有良好的边渗透性能'
            ],
            en: [
                'Easy to Form',
                'High Yield',
                'Low Waste Rate',
                'Eco-friendly and Biodegradable'
            ],
            ja: [
                '簡単に形成できる',
                '高い収率',
                '低い廃棄率',
                'エコフレンドリーでありがとう'
            ],
            Russian: [
                '簡単に形成できる',
                '高い収率',
                '低い廃棄率',
                'エコフレンドリーでありがとう'
            ],
            Malay: [
                '簡単に形成できる',
                '高い収率',
                '低い廃棄率',
                'エコフレンドリーでありがとう'
            ]
        },
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'QS认证',
                    en: 'ISO9001 Certification',
                    ja: 'ISO9001認証',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                icon: 'fa-shield-alt',
                name: {
                    zh: 'FSC认证',
                    en: 'Food Grade Certification',
                    ja: '食品レベル認証',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '135~350g/㎡',
                    en: 'Standard Specification',
                    ja: '標準仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '克重',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '根据需求定制',
                    en: 'Customized according to requirements',
                    ja: '要件に基づいてカスタマイズされます',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '成分',
                    en: 'Purity',
                    ja: '純度',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '原生竹浆、原生木浆',
                    en: '100%',
                    ja: '100%',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '指导价',
                    en: 'Purity',
                    ja: '純度',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '5100元/吨',
                    en: '100%',
                    ja: '100%',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '纸杯加工',
                    en: 'Food Packaging',
                    ja: 'フードパッケージ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '用于各类纸杯生产加工。',
                    en: 'Suitable for various food packaging',
                    ja: '様々な食品パッケージに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ZhiBeiShengChan.png'
            },
            {
                title: {
                    zh: '纸碗加工',
                    en: 'Food Packaging',
                    ja: 'フードパッケージ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '用于各类纸碗、纸餐具加工生产。',
                    en: 'Suitable for various food packaging',
                    ja: '様々な食品パッケージに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ZhiWanJiaGong.png'
            },
            {
                title: {
                    zh: '快餐桶加工',
                    en: 'Food Packaging',
                    ja: 'フードパッケージ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '用于各类纸桶、纸盒加工生产。',
                    en: 'Suitable for various food packaging',
                    ja: '様々な食品パッケージに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ZhiTongShengChan.png'
            }
        ],
        relatedProducts: ['packaging-001', 'packaging-002', 'packaging-003']
    },
    {
        id: 'packaging-005',
        title: {
            zh: '竹浆面碗原纸',
            en: 'Natural Color Food Packaging Paper (Kraft Paper)',
            ja: 'ナチュラルカラーフードパッケージペーパー（クラフトペーパー）',
            Russian: '仕様',
            Malay: '仕様'
        },
        category: 'packaging',
        desc: {
            zh: '原竹本色、未漂白、洁净度好',
            en: 'Natural bamboo color, unbleached, excellent cleanliness',
            ja: '天然のバンブーカラー、漂白されていない、非常に清潔です。',
            Russian: '仕様',
            Malay: '仕様'
        },
        img: '/images/mainProduction/ShiPinBaoZhuangZhi.jpg',
        gallery: [
            // '/images/mainProduction/NiuKaZhiSuoLve.png',
            // '/images/mainProduction/NiuKaZhiSuoLve.png',
            // '/images/mainProduction/NiuKaZhiSuoLve.png',
            '/images/mainProduction/ShiPinBaoZhuangZhi.jpg'
        ],
        features: {
            zh: [
                '无荧光增白剂',
                '未涂布、未淋膜，厚度均匀',
                '高松厚度、高挺度，无异味',
                '有良好的边渗透性能'
            ],
            en: [
                'Natural Bamboo Color',
                'Unbleached',
                'Excellent Cleanliness',
                'Eco-friendly and Biodegradable'
            ],
            ja: [
                '天然のバンブーカラー',
                '漂白されていない',
                '非常に清潔です',
                'エコフレンドリーでありがとう'
            ],
            Russian: [
                '天然のバンブーカラー',
                '漂白されていない',
                '非常に清潔です',
                'エコフレンドリーでありがとう'
            ],
            Malay: [
                '天然のバンブーカラー',
                '漂白されていない',
                '非常に清潔です',
                'エコフレンドリーでありがとう'
            ]
        },
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'QS认证',
                    en: 'ISO9001 Certification',
                    ja: 'ISO9001認証',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                icon: 'fa-shield-alt',
                name: {
                    zh: '食品级认证',
                    en: 'Food Grade Certification',
                    ja: '食品レベル認証',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '210~260 g/㎡',
                    en: 'Standard Specification',
                    ja: '標準仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '克重',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '根据需求定制',
                    en: 'Customized according to requirements',
                    ja: '要件に基づいてカスタマイズされます',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '指导价',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '5800元/吨',
                    en: 'Customized according to requirements',
                    ja: '要件に基づいてカスタマイズされます',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '食品包装',
                    en: 'Food Packaging',
                    ja: 'フードパッケージ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '用于各类面碗生产',
                    en: 'Suitable for various food packaging',
                    ja: '様々な食品パッケージに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ZhiWanJiaGong.png'
            }
        ],
        relatedProducts: ['packaging-006', 'packaging-007', 'packaging-008']
    },
    {
        id: 'packaging-006',
        title: {
            zh: '奶茶杯专用原纸',
            en: 'Natural Color Food Packaging Paper (Kraft Paper)',
            ja: 'ナチュラルカラーフードパッケージペーパー（クラフトペーパー）',
            Russian: '仕様',
            Malay: '仕様'
        },
        category: 'packaging',
        desc: {
            zh: '原竹本色、未漂白、洁净度好',
            en: 'Natural bamboo color, unbleached, excellent cleanliness',
            ja: '天然のバンブーカラー、漂白されていない、非常に清潔です。',
            Russian: '仕様',
            Malay: '仕様'
        },
        img: '/images/mainProduction/ZhiBeiXiGuan.jpg',
        gallery: [
            // '/images/mainProduction/NiuKaZhiSuoLve.png',
            // '/images/mainProduction/NiuKaZhiSuoLve.png',
            // '/images/mainProduction/NiuKaZhiSuoLve.png',
            '/images/mainProduction/ZhiBeiXiGuan.jpg'
        ],
        features: {
            zh: [
                '无荧光增白剂',
                '未涂布、未淋膜，厚度均匀',
                '无异味，符合国家食品安全要求',
                '有良好的边渗透性能'
            ],
            en: [
                'Natural Bamboo Color',
                'Unbleached',
                'Excellent Cleanliness',
                'Eco-friendly and Biodegradable'
            ],
            ja: [
                '天然のバンブーカラー',
                '漂白されていない',
                '非常に清潔です',
                'エコフレンドリーでありがとう'
            ],
            Russian: [
                '天然のバンブーカラー',
                '漂白されていない',
                '非常に清潔です',
                'エコフレンドリーでありがとう'
            ],
            Malay: [
                '天然のバンブーカラー',
                '漂白されていない',
                '非常に清潔です',
                'エコフレンドリーでありがとう'
            ]
        },
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'QS认证',
                    en: 'ISO9001 Certification',
                    ja: 'ISO9001認証',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                icon: 'fa-shield-alt',
                name: {
                    zh: '食品级认证',
                    en: 'Food Grade Certification',
                    ja: '食品レベル認証',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '标准规格',
                    en: 'Standard Specification',
                    ja: '標準仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '克重',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '240g/㎡',
                    en: 'Customized according to requirements',
                    ja: '要件に基づいてカスタマイズされます',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '指导价',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '5800元/吨',
                    en: 'Customized according to requirements',
                    ja: '要件に基づいてカスタマイズされます',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '食品包装',
                    en: 'Food Packaging',
                    ja: 'フードパッケージ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '用于各类奶茶杯生产',
                    en: 'Suitable for various food packaging',
                    ja: '様々な食品パッケージに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ZhiBeiShengChan.png'
            }
        ],
        relatedProducts: ['packaging-005', 'packaging-007', 'packaging-008']
    },
    {
        id: 'packaging-007',
        title: {
            zh: '竹浆吸管原纸',
            en: 'Natural Color Food Packaging Paper (Kraft Paper)',
            ja: 'ナチュラルカラーフードパッケージペーパー（クラフトペーパー）',
            Russian: '仕様',
            Malay: '仕様'
        },
        category: 'packaging',
        desc: {
            zh: '强度好、耐折高、洁净度好',
            en: 'Natural bamboo color, unbleached, excellent cleanliness',
            ja: '天然のバンブーカラー、漂白されていない、非常に清潔です。',
            Russian: '仕様',
            Malay: '仕様'
        },
        img: '/images/mainProduction/XiGuanSuoLve.png',
        gallery: [
            // '/images/mainProduction/NiuKaZhiSuoLve.png',
            // '/images/mainProduction/NiuKaZhiSuoLve.png',
            // '/images/mainProduction/NiuKaZhiSuoLve.png',
            '/images/mainProduction/XiGuanSuoLve.png'
        ],
        features: {
            zh: [
                '无荧光增白剂',
                '未涂布、未淋膜，厚度均匀',
                '无异味，符合国家食品安全要求',
                '有良好的边渗透性能'
            ],
            en: [
                'Natural Bamboo Color',
                'Unbleached',
                'Excellent Cleanliness',
                'Eco-friendly and Biodegradable'
            ],
            ja: [
                '天然のバンブーカラー',
                '漂白されていない',
                '非常に清潔です',
                'エコフレンドリーでありがとう'
            ],
            Russian: [
                '天然のバンブーカラー',
                '漂白されていない',
                '非常に清潔です',
                'エコフレンドリーでありがとう'
            ],
            Malay: [
                '天然のバンブーカラー',
                '漂白されていない',
                '非常に清潔です',
                'エコフレンドリーでありがとう'
            ]
        },
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'QS认证',
                    en: 'ISO9001 Certification',
                    ja: 'ISO9001認証',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                icon: 'fa-shield-alt',
                name: {
                    zh: '食品级认证',
                    en: 'Food Grade Certification',
                    ja: '食品レベル認証',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '100/120/150 g/㎡',
                    en: 'Standard Specification',
                    ja: '標準仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '克重',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '根据需求定制',
                    en: 'Customized according to requirements',
                    ja: '要件に基づいてカスタマイズされます',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '指导价',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '7800元/吨',
                    en: 'Customized according to requirements',
                    ja: '要件に基づいてカスタマイズされます',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '食品包装',
                    en: 'Food Packaging',
                    ja: 'フードパッケージ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '用于各类纸吸管生产',
                    en: 'Suitable for various food packaging',
                    ja: '様々な食品パッケージに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ZhiXiGuanShengChan.png'
            }
        ],
        relatedProducts: ['packaging-005', 'packaging-006', 'packaging-008']
    },
    {
        id: 'packaging-008',
        title: {
            zh: '纸杯',
            en: 'Paper Cup',
            ja: 'ペーパーカップ',
            Russian: '仕様',
            Malay: '仕様'
        },
        category: 'packaging',
        desc: {
            zh: '双层加厚不烫手，防止变形，无异味',
            en: 'Double-layer thickened, heat-resistant, deformation-resistant, odorless',
            ja: '二重に厚くて手に熱くない、変形しない、臭いがありません。',
            Russian: '仕様',
            Malay: '仕様'
        },
        img: '/images/ZhiBei.png',
        gallery: [
            // '/images/ZhiBei.png',
            // '/images/ZhiBei.png',
            // '/images/ZhiBei.png',
            '/images/ZhiBei.png'
        ],
        features: {
            zh: [
                '双层加厚',
                '不烫手',
                '防止变形',
                '无异味'
            ],
            en: [
                'Double-layer Thickened',
                'Heat-resistant',
                'Deformation-resistant',
                'Odorless'
            ],
            ja: [
                '二重に厚くて',
                '手に熱くない',
                '変形しない',
                '臭いがありません'
            ],
            Russian: [
                '二重に厚くて',
                '手に熱くない',
                '変形しない',
                '臭いがありません'
            ],
            Malay: [
                '二重に厚くて',
                '手に熱くない',
                '変形しない',
                '臭いがありません'
            ]
        },
        certifications: [
            // {
            //     icon: 'fa-certificate',
            //     name: {
            //         zh: 'ISO9001认证',
            //         en: 'ISO9001 Certification',
            //         ja: 'ISO9001認証'
            //     }
            // },
            // {
            //     icon: 'fa-shield-alt',
            //     name: {
            //         zh: '食品级认证',
            //         en: 'Food Grade Certification',
            //         ja: '食品レベル認証'
            //     }
            // }
        ],
        specifications: [
            {
                name: {
                    zh: '容量',
                    en: 'Capacity',
                    ja: '容量',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '多种规格可选',
                    en: 'Multiple sizes available',
                    ja: '様々なサイズが利用可能です',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Material',
                    ja: '素材',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '食品级竹浆纸',
                    en: 'Food-grade bamboo pulp paper',
                    ja: '食品レベルのバンブーパルプペーパー',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '家庭日用',
                    en: 'Drink Packaging',
                    ja: 'ドリンクパッケージ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适用于家庭日常使用',
                    en: 'Suitable for various drink packaging',
                    ja: '様々なドリンクパッケージに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ZhiBeijiaYong.png'
            },
            {
                title: {
                    zh: '商务接待',
                    en: 'Drink Packaging',
                    ja: 'ドリンクパッケージ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适用于会议、办公待客，商务接待',
                    en: 'Suitable for various drink packaging',
                    ja: '様々なドリンクパッケージに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ZhiBeiShangWuJieDai.png'
            },
            {
                title: {
                    zh: '旅行便携',
                    en: 'Drink Packaging',
                    ja: 'ドリンクパッケージ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适用于旅行便携',
                    en: 'Suitable for various drink packaging',
                    ja: '様々なドリンクパッケージに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ZhiBeiLuXingBianXie.png'
            }
        ],
        relatedProducts: ['packaging-006', 'packaging-007', 'packaging-009']
    },
    {
        id: 'packaging-009',
        title: {
            zh: '杯茶',
            en: 'Cup Tea',
            ja: 'カップティー',
            Russian: '仕様',
            Malay: '仕様'
        },
        category: 'packaging',
        desc: {
            zh: '杯茶一体，独立茶仓即冲即饮',
            en: 'Cup and tea in one, independent tea chamber, instant brewing and drinking',
            ja: 'カップとティーが一体で、独立したティーチェンバーで、すぐに淹れて飲むことができます。',
            Russian: '仕様',
            Malay: '仕様'
        },
        img: '/images/BeiCha.jpg',
        gallery: [
            // '/images/BeiCha.jpg',
            // '/images/BeiCha.jpg',
            // '/images/BeiCha.jpg',
            '/images/BeiCha.jpg'
        ],
        features: {
            zh: [
                '杯茶一体',
                '独立茶仓',
                '即冲即饮',
                '方便携带'
            ],
            en: [
                'Cup and tea in one',
                'Independent tea chamber',
                'Instant brewing and drinking',
                'Easy to carry'
            ],
            ja: [
                'カップとティーが一体で',
                '独立したティーチェンバーで',
                'すぐに淹れて飲むことができます',
                '持ち運びが簡単です'
            ],
            Russian: [
                'カップとティーが一体で',
                '独立したティーチェンバーで',
                'すぐに淹れて飲むことができます',
                '持ち運びが簡単です'
            ],
            Malay: [
                'カップとティーが一体で',
                '独立したティーチェンバーで',
                'すぐに淹れて飲むことができます',
                '持ち運びが簡単です'
            ]
        },
        certifications: [
            // {
            //     icon: 'fa-certificate',
            //     name: {
            //         zh: 'ISO9001认证',
            //         en: 'ISO9001 Certification',
            //         ja: 'ISO9001認証'
            //     }
            // },
            // {
            //     icon: 'fa-shield-alt',
            //     name: {
            //         zh: '食品级认证',
            //         en: 'Food Grade Certification',
            //         ja: '食品レベル認証'
            //     }
            // }
        ],
        specifications: [
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '350ML/杯',
                    en: 'Standard Specification',
                    ja: '標準仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '容量',
                    en: 'Capacity',
                    ja: '容量',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '350ML/杯',
                    en: 'Multiple sizes available',
                    ja: '様々なサイズが利用可能です',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '家庭日用',
                    en: 'Drink Packaging',
                    ja: 'ドリンクパッケージ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适用于家庭日常使用',
                    en: 'Suitable for various drink packaging',
                    ja: '様々なドリンクパッケージに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ZhiBeijiaYong.png'
            },
            {
                title: {
                    zh: '商务接待',
                    en: 'Drink Packaging',
                    ja: 'ドリンクパッケージ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适用于会议、办公待客，商务接待',
                    en: 'Suitable for various drink packaging',
                    ja: '様々なドリンクパッケージに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ZhiBeiShangWuJieDai.png'
            },
            {
                title: {
                    zh: '旅行便携',
                    en: 'Drink Packaging',
                    ja: 'ドリンクパッケージ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适用于旅行便携',
                    en: 'Suitable for various drink packaging',
                    ja: '様々なドリンクパッケージに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ZhiBeiLuXingBianXie.png'
            }
        ],
        relatedProducts: ['packaging-006', 'packaging-007', 'packaging-008']
    },
    {
        id: 'packaging-010',
        title: {
            zh: '管芯原纸',
            en: 'Bamboo Pulp Food Packaging Paper',
            ja: 'バンブーパルプフードパッケージペーパー',
            Russian: '仕様',
            Malay: '仕様'
        },
        category: 'packaging',
        desc: {
            zh: '厚度均匀、无异味',
            en: 'Good strength, high folding resistance, excellent cleanliness and printability',
            ja: '強度があり、折りにくく、非常に清潔であり、印刷に適しています。',
            Russian: '仕様',
            Malay: '仕様'
        },
        img: '/images/mainProduction/GuanXinYuanZhi.png',
        gallery: [
            // '/images/mainProduction/KeDingZhiShiPinBaoZhuangSuoLveTu.png',
            // '/images/mainProduction/KeDingZhiShiPinBaoZhuangSuoLveTu.png',
            // '/images/mainProduction/KeDingZhiShiPinBaoZhuangSuoLveTu.png',
            '/images/mainProduction/GuanXinYuanZhi.png'
        ],
        features: {
            zh: [
                '原生竹浆',
                '厚度均匀',
                '无异味',
                '颜色自然'
            ],
            en: [
                'Good Strength',
                'High Folding Resistance',
                'Excellent Cleanliness',
                'Good Printability'
            ],
            ja: [
                '強度があり',
                '折りにくく',
                '非常に清潔であり',
                '印刷に適しています'
            ],
            Russian: [
                '強度があり',
                '折りにくく',
                '非常に清潔であり',
                '印刷に適しています'
            ],
            Malay: [
                '強度があり',
                '折りにくく',
                '非常に清潔であり',
                '印刷に適しています'
            ]
        },
        certifications: [
            // {
            //     icon: 'fa-certificate',
            //     name: {
            //         zh: 'ISO9001认证',
            //         en: 'ISO9001 Certification',
            //         ja: 'ISO9001認証'
            //     }
            // },
            // {
            //     icon: 'fa-shield-alt',
            //     name: {
            //         zh: '食品级认证',
            //         en: 'Food Grade Certification',
            //         ja: '食品レベル認証'
            //     }
            // }
        ],
        specifications: [
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '190/210/250 g/㎡',
                    en: 'Standard Specification',
                    ja: '標準仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '克重',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '根据需求定制',
                    en: 'Customized according to requirements',
                    ja: '要件に基づいてカスタマイズされます',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '非食品包装',
                    en: 'Food Packaging',
                    ja: 'フードパッケージ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '用于卫生纸纸芯生产',
                    en: 'Suitable for various food packaging',
                    ja: '様々な食品パッケージに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/GuanXinYuanZhi.png'
            }
        ],
        relatedProducts: ['packaging-011', 'cultural-002', 'cultural-004']
    },
    {
        id: 'packaging-011',
        title: {
            zh: '通用包装箱',
            en: 'Bamboo Pulp Food Packaging Paper',
            ja: 'バンブーパルプフードパッケージペーパー',
            Russian: '仕様',
            Malay: '仕様'
        },
        category: 'packaging',
        desc: {
            zh: '低碳环保、可回收循环利用',
            en: 'Good strength, high folding resistance, excellent cleanliness and printability',
            ja: '強度があり、折りにくく、非常に清潔であり、印刷に適しています。',
            Russian: '仕様',
            Malay: '仕様'
        },
        img: '/images/mainProduction/TongYongBaoZhuangXiangSuoLve.png',
        gallery: [
            // '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
            // '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
            // '/images/mainProduction/ShiPinBaoZhuangYuanZhi1SuoLve.png',
            '/images/mainProduction/TongYongBaoZhuangXiangSuoLve.png'
        ],
        features: {
            zh: [
                '低碳环保',
                '质量好',
                '性价比高',
                '可回收循环利用'
            ],
            en: [
                'Good Strength',
                'High Folding Resistance',
                'Excellent Cleanliness',
                'Good Printability'
            ],
            ja: [
                '強度があり',
                '折りにくく',
                '非常に清潔であり',
                '印刷に適しています'
            ],
            Russian: [
                '強度があり',
                '折りにくく',
                '非常に清潔であり',
                '印刷に適しています'
            ],
            Malay: [
                '強度があり',
                '折りにくく',
                '非常に清潔であり',
                '印刷に適しています'
            ]
        },
        certifications: [
            // {
            //     icon: 'fa-certificate',
            //     name: {
            //         zh: 'ISO9001认证',
            //         en: 'ISO9001 Certification',
            //         ja: 'ISO9001認証'
            //     }
            // },
            // {
            //     icon: 'fa-shield-alt',
            //     name: {
            //         zh: '食品级认证',
            //         en: 'Food Grade Certification',
            //         ja: '食品レベル認証'
            //     }
            // }
        ],
        specifications: [
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '标准规格',
                    en: 'Standard Specification',
                    ja: '標準仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '克重',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '根据需求定制',
                    en: 'Customized according to requirements',
                    ja: '要件に基づいてカスタマイズされます',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '包装周转箱',
                    en: 'Food Packaging',
                    ja: 'フードパッケージ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '白酒类、医药类、电子类、食品饮料类、水果类、农副产品类、工业产品类包装/周转箱',
                    en: 'Suitable for various food packaging',
                    ja: '様々な食品パッケージに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/newMaterial/6SuoLue.png'
            }
        ],
        relatedProducts: ['packaging-010', 'cultural-002', 'cultural-004']
    },
    {
        id: 'cultural-001',
        title: { zh: '金竹A4纸', en: 'Jin Zhu A4 Paper', ja: 'ジンズーA4紙', Russian: 'ジンズーA4紙', Malay: 'ジンズーA4紙' },
        category: 'cultural',
        desc: { zh: '质地光滑洁净，厚度适中', en: 'Smooth and clean texture, moderate thickness', ja: '滑らかで清潔であり、厚さが適度にあります。', Russian: 'ジンズーA4紙', Malay: 'ジンズーA4紙' },
        img: '/images/mainProduction/JinZhuA4SuoLve.png',
        gallery: ['/images/mainProduction/JinZhuA4SuoLve.png'],
        features: { zh: ['质地光滑洁净', '厚度适中', '白度高，强度好'], en: ['High quality bamboo pulp', 'Moderate thickness', 'Smooth and clean'], ja: ['高品質のバンブーパルプ', '適度の厚さ', '滑らかで清潔であります。'], Russian: ['高品質のバンブーパルプ', '適度の厚さ', '滑らかで清潔であります。'], Malay: ['高品質のバンブーパルプ', '適度の厚さ', '滑らかで清潔であります。'] },
        certifications: [],
        specifications: [
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '500张/包',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '克重',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '70g/m',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '商务会议用',
                    en: 'Home Daily Use',
                    ja: 'ホームデイリー使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适用于商务会议等场景',
                    en: 'Suitable for daily cleaning and wiping in households',
                    ja: 'ホームデイリーでのクリーニングとワイプに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ShangWuDingZhiLingYuSuoLve.png'
            },
            {
                title: {
                    zh: '教育办公用',
                    en: 'Home Daily Use',
                    ja: 'ホームデイリー使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适用于教育办公等场景',
                    en: 'Suitable for daily cleaning and wiping in households',
                    ja: 'ホームデイリーでのクリーニングとワイプに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/BanGongJiaoYuSuoLve.png'
            }
        ],
        relatedProducts: ['cultural-002', 'cultural-003', 'cultural-004']
    },
    {
        id: 'cultural-002',
        title: { zh: '原生竹浆牛皮纸', en: 'Virgin Bamboo Kraft Paper', ja: 'バージンバンブークラフトペーパー', Russian: 'バージンバンブークラフトペーパー', Malay: 'バージンバンブークラフトペーパー' },
        category: 'cultural',
        desc: { zh: '原生竹纤维，色泽光亮，拉力好', en: 'Virgin bamboo fiber, bright color, good tensile strength', ja: 'バージンバンブーファイバー、明るい色、良好な引張強度があります。', Russian: 'バージンバンブークラフトペーパー', Malay: 'バージンバンブークラフトペーパー'  },
        img: '/images/mainProduction/NiuPiZhiSuoLve.png',
        gallery: ['/images/mainProduction/NiuPiZhiSuoLve.png'],
        features: { zh: ['原生竹纤维', '色泽光亮', '拉力好,强度高'], en: ['Virgin bamboo fiber', 'Bright color', 'Good tensile strength'], ja: ['バージンバンブーファイバー', '明るい色', '良好な引張強度があります。'], Russian: ['バージンバンブーファイバー', '明るい色', '良好な引張強度があります。'], Malay: ['バージンバンブーファイバー', '明るい色', '良好な引張強度があります。'] },
        certifications: [],
        specifications: [
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '可根据需求定制',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '包装封装',
                    en: 'Home Daily Use',
                    ja: 'ホームデイリー使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '应用于档案袋、手提袋、信封等领域',
                    en: 'Suitable for daily cleaning and wiping in households',
                    ja: 'ホームデイリーでのクリーニングとワイプに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/NiuPiZhiShouTiDai.png'
            },
            {
                title: {
                    zh: '工业印刷',
                    en: 'Home Daily Use',
                    ja: 'ホームデイリー使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '应用于工业包装、印刷等领域',
                    en: 'Suitable for daily cleaning and wiping in households',
                    ja: 'ホームデイリーでのクリーニングとワイプに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/NiuPiZhiBaoZhuangYinShua.png'
            },
            {
                title: {
                    zh: '淋膜再加工',
                    en: 'Home Daily Use',
                    ja: 'ホームデイリー使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '应用于印刷、淋膜，纸棒等领域',
                    en: 'Suitable for daily cleaning and wiping in households',
                    ja: 'ホームデイリーでのクリーニングとワイプに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/GongYeZhiZaoLingYuSuoLve.png'
            }
        ],
        relatedProducts: ['cultural-001', 'cultural-003', 'cultural-004']
    },
    {
        id: 'cultural-003',
        title: { zh: '竹浆本色热压垫板纸', en: 'Electronic Hot Press Paper', ja: '電子ホットプレスペーパー', Russian: '電子ホットプレスペーパー', Malay: '電子ホットプレスペーパー' },
        category: 'cultural',
        desc: { zh: '抗压、耐热性好，使用次数高', en: 'Good pressure resistance, heat resistance, high usage times', ja: '強度に優れ、熱に強く、使用回数が多いです。', Russian: '電子ホットプレスペーパー', Malay: '電子ホットプレスペーパー' },
        img: '/images/mainProduction/DianZiYeYaZhiSuoLve.png',
        gallery: ['/images/mainProduction/DianZiYeYaZhiSuoLve.png'],
        features: { zh: ['抗压', '耐热性好', '使用次数高'], en: ['Pressure resistant', 'Good heat resistance', 'High usage times'], ja: ['強度に優れ', '熱に強く', '使用回数が多いです。'], Russian: ['強度に優れ', '熱に強く', '使用回数が多いです。'], Malay: ['強度に優れ', '熱に強く', '使用回数が多いです。'] },
        certifications: [],
        specifications: [
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '150~320 g/㎡',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '100%原生竹浆',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '工业制造',
                    en: 'Home Daily Use',
                    ja: 'ホームデイリー使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '用于PCB行业电路板热压',
                    en: 'Suitable for daily cleaning and wiping in households',
                    ja: 'ホームデイリーでのクリーニングとワイプに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ReYaZhiPCB.png'
            }
        ],
        relatedProducts: ["cultural-001", 'cultural-002', 'cultural-004']
    },
    {
        id: 'cultural-004',
        title: { zh: '彩票专用原纸', en: 'Electronic Hot Press Paper', ja: '電子ホットプレスペーパー', Russian: '電子ホットプレスペーパー', Malay: '電子ホットプレスペーパー' },
        category: 'cultural',
        desc: { zh: '无荧光增白剂，厚度均匀，无异味', en: 'Good pressure resistance, heat resistance, high usage times', ja: '強度に優れ、熱に強く、使用回数が多いです。', Russian: '電子ホットプレスペーパー', Malay: '電子ホットプレスペーパー' },
        img: '/images/mainProduction/DianZiYeYaZhiSuoLve.png',
        gallery: ['/images/mainProduction/DianZiYeYaZhiSuoLve.png'],
        features: { zh: ['无荧光增白剂', '未涂布、未淋膜', '厚度均匀，无异味'], en: ['Pressure resistant', 'Good heat resistance', 'High usage times'], ja: ['強度に優れ', '熱に強く', '使用回数が多いです。'], Russian: ['強度に優れ', '熱に強く', '使用回数が多いです。'], Malay: ['強度に優れ', '熱に強く', '使用回数が多いです。'] },
        certifications: [],
        specifications: [
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '135/150 g/㎡',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '原生竹浆、原生木浆',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '彩票、游戏币生产',
                    en: 'Home Daily Use',
                    ja: 'ホームデイリー使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '用于各类彩票、游戏币生产',
                    en: 'Suitable for daily cleaning and wiping in households',
                    ja: 'ホームデイリーでのクリーニングとワイプに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/CaiPiaoZhuanYong.png'
            }
        ],
        relatedProducts: ["cultural-001", 'cultural-002', 'cultural-003']
    },
    {
        id: 'rawpaper-001',
        title: { zh: '本色原纸', en: 'Natural Color Raw Paper', ja: 'ナチュラルカラー生地紙', Russian: 'ナチュラルカラー生地紙', Malay: 'ナチュラルカラー生地紙' },
        category: 'rawpaper',
        desc: { zh: '色泽金黄、强度好、洁净度好', en: 'Golden color, good strength, good cleanliness', ja: '金色、強度があり、非常に清潔です。', Russian: 'ナチュラルカラー生地紙', Malay: 'ナチュラルカラー生地紙' },
        img: '/images/mainProduction/ShengHuoYuanZhi2SuoLve.png',
        gallery: ['/images/mainProduction/ShengHuoYuanZhi2SuoLve.png'],
        features: { zh: ['湿水强韧', '绿色环保', '天然抑菌'], en: ['Golden color', 'Good strength', 'Good cleanliness'], ja: ['金色', '強度があり', '非常に清潔です。'], Russian: ['金色', '強度があり', '非常に清潔です。'], Malay: ['金色', '強度があり', '非常に清潔です。'] },
        certifications: [],
        specifications: [
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '高伸长率、中纹、细纹系列',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '全竹浆',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '颜色',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '本色',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '克重',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '13.5-35g',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '1',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '拉伸膜',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: 'T/SCSZX002-2021',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '指导价',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '5800元/吨',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '生活用纸产品加工',
                    en: 'Home Daily Use',
                    ja: 'ホームデイリー使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '应用于各类生活用纸产品加工，抽纸、卷纸、盘纸、擦手纸、厨房纸等',
                    en: 'Suitable for daily cleaning and wiping in households',
                    ja: 'ホームデイリーでのクリーニングとワイプに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/finishedPaper/QuanXiLieSuoLve.png'
            }
        ],
        relatedProducts: ['rawpaper-002', 'rawpaper-003', 'packaging-001']
    },
    {
        id: 'rawpaper-002',
        title: { zh: '白色原纸', en: 'White Raw Paper', ja: 'ホワイト生地紙', Russian: 'ホワイト生地紙', Malay: 'ホワイト生地紙' },
        category: 'rawpaper',
        desc: { zh: '绿色环保、天然抑菌、成品包型好', en: 'Eco-friendly, natural antibacterial, good finished package shape', ja: 'エコフレンドリー、天然抗菌、完成パッケージ形状が良好です。', Russian: 'ホワイト生地紙', Malay: 'ホワイト生地紙' },
        img: '/images/mainProduction/ShengHuoYuanZhi1SuoLve.png',
        gallery: ['/images/mainProduction/ShengHuoYuanZhi1SuoLve.png'],
        features: { zh: ['强度好、拉力高', '洁净度好', '湿水强韧'], en: ['Eco-friendly', 'Natural antibacterial', 'Good finished package shape'], ja: ['エコフレンドリー', '天然抗菌', '完成パッケージ形状が良好です。'], Russian: ['エコフレンドリー', '天然抗菌', '完成パッケージ形状が良好です。'], Malay: ['エコフレンドリー', '天然抗菌', '完成パッケージ形状が良好です。'] },
        certifications: [],
        specifications: [
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '高伸长率、中纹、细纹系列',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '全竹浆',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '颜色',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '白色',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '克重',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '13.5-35g',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '1',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '拉伸膜',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: 'T/SCSZX002-2021',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '指导价',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '6350元/吨',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '生活用纸产品加工',
                    en: 'Home Daily Use',
                    ja: 'ホームデイリー使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '应用于各类生活用纸产品加工，抽纸、卷纸、盘纸、擦手纸、厨房纸等',
                    en: 'Suitable for daily cleaning and wiping in households',
                    ja: 'ホームデイリーでのクリーニングとワイプに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/finishedPaper/QuanXiLieSuoLve.png'
            }
        ],
        relatedProducts: ['rawpaper-001', 'rawpaper-003', 'packaging-001']
    },
    {
        id: 'rawpaper-003',
        title: { zh: '吸水衬纸', en: 'Absorbent Liner Paper', ja: '吸水シート紙', Russian: '吸水シート紙', Malay: '吸水シート紙' },
        category: 'rawpaper',
        desc: { zh: '湿水强韧、洁净度好、吸水均匀速度快', en: 'Strong when wet, good cleanliness, fast and even water absorption', ja: '湿ったときに強くて清潔であり、速くて均一な水吸収があります。', Russian: '吸水シート紙', Malay: '吸水シート紙' },
        img: '/images/mainProduction/ShengHuoYuanZhi3SuoLve.png',
        gallery: ['/images/mainProduction/ShengHuoYuanZhi3SuoLve.png'],
        features: { zh: ['湿水强韧', '洁净度好', '吸水均匀速度快'], en: ['Strong when wet', 'Good cleanliness', 'Fast and even water absorption'], ja: ['湿ったときに強くて清潔であり', '速くて均一な水吸収があります。'], Russian: ['湿ったときに強くて清潔であり', '速くて均一な水吸収があります。'], Malay: ['湿ったときに強くて清潔であり', '速くて均一な水吸収があります。'] },
        certifications: [],
        specifications: [
            {
                name: {
                    zh: '材质',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '全竹浆',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '颜色',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '白色',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '克重',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '13.5g',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '1',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '拉伸膜',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: 'T/SCSZX002-2021',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '指导价',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '6350元/吨',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '生活用纸产品加工',
                    en: 'Home Daily Use',
                    ja: 'ホームデイリー使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '应用于婴幼儿、成人卫生纸尿裤、护理垫加工',
                    en: 'Suitable for daily cleaning and wiping in households',
                    ja: 'ホームデイリーでのクリーニングとワイプに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/XiShuiCunZhi.png'
            }
        ],
        relatedProducts: ['rawpaper-001', 'rawpaper-002', 'packaging-001']
    },
    {
        id: 'finishedpaper-001',
        title: {
            zh: '山水可湿水软抽',
            en: 'Bamboo Tissue Paper',
            ja: 'バンブーティッシュペーパー',
            Russian: '仕様',
            Malay: '仕様'
        },
        category: 'finishedpaper',
        desc: {
            zh: '原生竹浆，绿色健康',
            en: 'High-quality tissue paper made from 100% premium bamboo pulp, preserving the natural flexibility and antibacterial properties of bamboo fibers, providing a healthier and more eco-friendly choice for your family.\nWe use innovative natural color technology, reducing the bleaching process while maintaining the natural properties and flexibility of bamboo fibers, with excellent water absorption and strength, allowing you to experience the gentle touch and reliable quality of bamboo fibers in daily use.',
            ja: '100%の優れたバンブーパルプで作られた高品質な生活用紙。竹の繊維の天然の弾力と抗菌特性を維持しながら、優れた吸水性と強度を持ち、毎日の使用中に竹の繊維が与えるやさしい感触と信頼性の高い品質を体験できます。',
            Russian: '仕様',
            Malay: '仕様'
        },
        img: '/images/finishedPaper/ShanShuiKeShiShuiRuanChouSuoLve.png',
        gallery: [
            // '/images/6.png',
            // '/images/10.png',
            // '/images/19.jpg',
            '/images/finishedPaper/ShanShuiKeShiShuiRuanChouSuoLve.png',
        ],
        features: {
            zh: [
                '100%原生竹浆制造',
                '超强吸水性能',
                '柔软亲肤',
                '环保可降解',
                '无荧光剂添加'
            ],
            en: [
                'Made from 100% virgin bamboo pulp',
                'Superior water absorption',
                'Soft and skin-friendly',
                'Eco-friendly and biodegradable',
                'No fluorescent agents added'
            ],
            ja: [
                '100%バージンバンブーパルプで作られた',
                '優れた吸水性',
                '肌に優しい',
                'エコフレンドリーでありがとう',
                '蛍光剤を添加していません'
            ],
            Russian: [
                '100%バージンバンブーパルプで作られた',
                '優れた吸水性',
                '肌に優しい',
                'エコフレンドリーでありがとう',
                '蛍光剤を添加していません'
            ],
            Malay: [
                '100%バージンバンブーパルプで作られた',
                '優れた吸水性',
                '肌に優しい',
                'エコフレンドリーでありがとう',
                '蛍光剤を添加していません'
            ]
        },
        certifications: [
            {
                icon: 'fa-certificate',
                name: {
                    zh: 'ISO9001认证',
                    en: 'ISO9001 Certification',
                    ja: 'ISO9001認証',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                icon: 'fa-leaf',
                name: {
                    zh: 'FSC认证',
                    en: 'FSC Certification',
                    ja: 'FSC認証',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                icon: 'fa-shield-alt',
                name: {
                    zh: '食品级认证',
                    en: 'Food Grade Certification',
                    ja: '食品レベル認証',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '竹浆本色',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '原生竹浆',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '155mmx190mm',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Layers',
                    ja: '層数',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '3层',
                    en: '3 layers',
                    ja: '3層',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '130抽',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '山水系列',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '干湿两用',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: 'GB/T 20808',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '指导价',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '4.75元/包',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '家庭日常',
                    en: 'Home Daily Use',
                    ja: 'ホームデイリー使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适用于家庭日常清洁、擦拭等用途',
                    en: 'Suitable for daily cleaning and wiping in households',
                    ja: 'ホームデイリーでのクリーニングとワイプに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/JiaTingShengHuoSuoLve.png'
            },
            {
                title: {
                    zh: '餐饮服务',
                    en: 'Office Use',
                    ja: 'オフィス使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '可用于餐厅、咖啡厅等场所',
                    en: 'Suitable for use in offices and conference rooms',
                    ja: 'オフィスや会議室などで使用に適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ChouZhiCanYin.png'
            },
            {
                title: {
                    zh: '商务会议接待',
                    en: 'Food Service',
                    ja: 'フードサービス',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适合办公室、会议室等场所定制化使用',
                    en: 'Can be used in restaurants and cafes',
                    ja: 'レストランやカフェなどで使用できます',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ChouZhiShangWuHuiYi.png'
            }
        ],
        relatedProducts: ['finishedpaper-008', 'finishedpaper-009', 'finishedpaper-013']
    },
    {
        id: 'finishedpaper-002',
        title: { zh: '竹韵185软抽', en: 'Shanshui Wet Tissue', ja: 'シャンシウイッシュルチョウ', Russian: 'シャンシウイッシュルチョウ', Malay: 'シャンシウイッシュルチョウ' },
        category: 'finishedpaper',
        desc: { zh: '原生竹浆，绿色健康', en: 'Virgin bamboo pulp, green and healthy', ja: 'バージンバンブーパルプ、緑と健康です。', Russian: 'シャンシウイッシュルチョウ', Malay: 'シャンシウイッシュルチョウ' },
        img: '/images/finishedPaper/ZhuYun185RuanChouSuoLve.png',
        gallery: ['/images/finishedPaper/ZhuYun185RuanChouSuoLve.png'],
        features: { zh: ['100%原生竹浆制造','超强吸水性能','柔软亲肤','环保可降解','无荧光剂添加'], en: ['Virgin bamboo pulp', 'Green and healthy'], ja: ['バージンバンブーパルプ', '緑と健康です。'], Russian: ['バージンバンブーパルプ', '緑と健康です。'], Malay: ['バージンバンブーパルプ', '緑と健康です。'] },
        certifications: [{icon:'fa-certificate',name:{zh:'ISO9001认证',en:'ISO9001 Certification',ja:'ISO9001認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-leaf',name:{zh:'FSC认证',en:'FSC Certification',ja:'FSC認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-shield-alt',name:{zh:'食品级认证',en:'Food Grade Certification',ja:'食品レベル認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}}],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '竹浆本色',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '原生竹浆',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '185mmx190mm',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Layers',
                    ja: '層数',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '3层',
                    en: '3 layers',
                    ja: '3層',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '140抽',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '竹韵系列',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '干湿两用',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: 'T/SCSZX 002',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '指导价',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '4.99元/包 ',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '家庭日常',
                    en: 'Home Daily Use',
                    ja: 'ホームデイリー使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适用于家庭日常清洁、擦拭等用途',
                    en: 'Suitable for daily cleaning and wiping in households',
                    ja: 'ホームデイリーでのクリーニングとワイプに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/JiaTingShengHuoSuoLve.png'
            },
            {
                title: {
                    zh: '餐饮服务',
                    en: 'Office Use',
                    ja: 'オフィス使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '可用于餐厅、咖啡厅等场所',
                    en: 'Suitable for use in offices and conference rooms',
                    ja: 'オフィスや会議室などで使用に適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ChouZhiCanYin.png'
            },
            {
                title: {
                    zh: '商务会议接待',
                    en: 'Food Service',
                    ja: 'フードサービス',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适合办公室、会议室等场所定制化使用',
                    en: 'Can be used in restaurants and cafes',
                    ja: 'レストランやカフェなどで使用できます',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ChouZhiShangWuHuiYi.png'
            }
        ],
        relatedProducts: ['finishedpaper-003', 'finishedpaper-011', 'finishedpaper-014']
    },
    {
        id: 'finishedpaper-003',
        title: { zh: '竹韵165软抽', en: 'Zhuyun 185 Soft Tissue', ja: 'ジュヨンイチハイロウルチョウ', Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ' },
        category: 'finishedpaper',
        desc: { zh: '原生竹浆，绿色健康', en: 'Virgin bamboo pulp, green and healthy', ja: 'バージンバンブーパルプ、緑と健康です。', Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ' },
        img: '/images/finishedPaper/ZhuYun165RuanChouSuoLve.png',
        gallery: ['/images/finishedPaper/ZhuYun165RuanChouSuoLve.png'],
        features: { zh: ['100%原生竹浆制造','超强吸水性能','柔软亲肤','环保可降解','无荧光剂添加'], en: ['Virgin bamboo pulp', 'Green and healthy'], ja: ['バージンバンブーパルプ', '緑と健康です。'], Russian: ['バージンバンブーパルプ', '緑と健康です。'], Malay: ['バージンバンブーパルプ', '緑と健康です。']  },
        certifications: [{icon:'fa-certificate',name:{zh:'ISO9001认证',en:'ISO9001 Certification',ja:'ISO9001認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-leaf',name:{zh:'FSC认证',en:'FSC Certification',ja:'FSC認証',Russian:'FSC認証',Malay:'FSC認証'}},{icon:'fa-shield-alt',name:{zh:'食品级认证',en:'Food Grade Certification',ja:'食品レベル認証',Russian:'FSC認証',Malay:'FSC認証'}}],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '竹浆本色',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '原生竹浆',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '165mmx190mm',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Layers',
                    ja: '層数',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '3层',
                    en: '3 layers',
                    ja: '3層',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '134抽',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '竹韵系列',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '干湿两用',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: 'T/SCSZX 002',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '指导价',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '4.06元/包 ',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '家庭日常',
                    en: 'Home Daily Use',
                    ja: 'ホームデイリー使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适用于家庭日常清洁、擦拭等用途',
                    en: 'Suitable for daily cleaning and wiping in households',
                    ja: 'ホームデイリーでのクリーニングとワイプに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/JiaTingShengHuoSuoLve.png'
            },
            {
                title: {
                    zh: '餐饮服务',
                    en: 'Office Use',
                    ja: 'オフィス使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '可用于餐厅、咖啡厅等场所',
                    en: 'Suitable for use in offices and conference rooms',
                    ja: 'オフィスや会議室などで使用に適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ChouZhiCanYin.png'
            },
            {
                title: {
                    zh: '商务会议接待',
                    en: 'Food Service',
                    ja: 'フードサービス',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适合办公室、会议室等场所定制化使用',
                    en: 'Can be used in restaurants and cafes',
                    ja: 'レストランやカフェなどで使用できます',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ChouZhiShangWuHuiYi.png'
            }
        ],
        relatedProducts: ['finishedpaper-002', 'finishedpaper-011', 'finishedpaper-014']
    },
    {
        id: 'finishedpaper-004',
        title: { zh: '哪吒155软抽', en: 'Zhuyun 185 Soft Tissue', ja: 'ジュヨンイチハイロウルチョウ', Russian: 'ジュヨンイチハイロウルチョウ' , Malay: 'ジュヨンイチハイロウルチョウ'  },
        category: 'finishedpaper',
        desc: { zh: '原生竹浆，绿色健康', en: 'Virgin bamboo pulp, green and healthy', ja: 'バージンバンブーパルプ、緑と健康です。', Russian: 'ジュヨンイチハイロウルチョウ' , Malay: 'ジュヨンイチハイロウルチョウ' },
        img: '/images/finishedPaper/NeZha155RuanChouSuoLve.png',
        gallery: ['/images/finishedPaper/NeZha155RuanChouSuoLve.png'],
        features: { zh: ['100%原生竹浆制造','超强吸水性能','柔软亲肤','环保可降解','无荧光剂添加'], en: ['Virgin bamboo pulp', 'Green and healthy'], ja: ['バージンバンブーパルプ', '緑と健康です。'], Russian: ['バージンバンブーパルプ', '緑と健康です。'], Malay: ['バージンバンブーパルプ', '緑と健康です。']  },
        certifications: [{icon:'fa-certificate',name:{zh:'ISO9001认证',en:'ISO9001 Certification',ja:'ISO9001認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-leaf',name:{zh:'FSC认证',en:'FSC Certification',ja:'FSC認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-shield-alt',name:{zh:'食品级认证',en:'Food Grade Certification',ja:'食品レベル認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}}],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '竹浆本色',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '原生竹浆',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '155mmx190mm',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Layers',
                    ja: '層数',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '3层',
                    en: '3 layers',
                    ja: '3層',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '130抽',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '哪吒系列',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '干湿两用',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: 'GB/T 20808',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '指导价',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '4.2元/包 ',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '家庭日常',
                    en: 'Home Daily Use',
                    ja: 'ホームデイリー使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适用于家庭日常清洁、擦拭等用途',
                    en: 'Suitable for daily cleaning and wiping in households',
                    ja: 'ホームデイリーでのクリーニングとワイプに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/JiaTingShengHuoSuoLve.png'
            },
            {
                title: {
                    zh: '餐饮服务',
                    en: 'Office Use',
                    ja: 'オフィス使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '可用于餐厅、咖啡厅等场所',
                    en: 'Suitable for use in offices and conference rooms',
                    ja: 'オフィスや会議室などで使用に適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ChouZhiCanYin.png'
            },
            {
                title: {
                    zh: '商务会议接待',
                    en: 'Food Service',
                    ja: 'フードサービス',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适合办公室、会议室等场所定制化使用',
                    en: 'Can be used in restaurants and cafes',
                    ja: 'レストランやカフェなどで使用できます',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ChouZhiShangWuHuiYi.png'
            }
        ],
        relatedProducts: ['finishedpaper-005', 'finishedpaper-010', 'finishedpaper-006']
    },
    {
        id: 'finishedpaper-005',
        title: { zh: '哪吒135抽纸', en: 'Zhuyun 185 Soft Tissue', ja: 'ジュヨンイチハイロウルチョウ', Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ' },
        category: 'finishedpaper',
        desc: { zh: '原生竹浆，绿色健康', en: 'Virgin bamboo pulp, green and healthy', ja: 'バージンバンブーパルプ、緑と健康です。', Russian: 'バージンバンブーパルプ、緑と健康です。', Malay: 'バージンバンブーパルプ、緑と健康です。' },
        img: '/images/finishedPaper/NeZha135ChouZhiSuoLve.png',
        gallery: ['/images/finishedPaper/NeZha135ChouZhiSuoLve.png'],
        features: { zh: ['100%原生竹浆制造','超强吸水性能','柔软亲肤','环保可降解','无荧光剂添加'], en: ['Virgin bamboo pulp', 'Green and healthy'], ja: ['バージンバンブーパルプ', '緑と健康です。'], Russian: ['バージンバンブーパルプ', '緑と健康です。'] , Malay: ['バージンバンブーパルプ', '緑と健康です。']   },
        certifications: [{icon:'fa-certificate',name:{zh:'ISO9001认证',en:'ISO9001 Certification',ja:'ISO9001認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-leaf',name:{zh:'FSC认证',en:'FSC Certification',ja:'FSC認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-shield-alt',name:{zh:'食品级认证',en:'Food Grade Certification',ja:'食品レベル認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}}],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '竹浆本色',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '原生竹浆',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '135mmx190mm',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Layers',
                    ja: '層数',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '3层',
                    en: '3 layers',
                    ja: '3層',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '120抽',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '哪吒系列',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '干湿两用',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: 'GB/T 20808',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '指导价',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '3元/包 ',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '家庭日常',
                    en: 'Home Daily Use',
                    ja: 'ホームデイリー使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适用于家庭日常清洁、擦拭等用途',
                    en: 'Suitable for daily cleaning and wiping in households',
                    ja: 'ホームデイリーでのクリーニングとワイプに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/JiaTingShengHuoSuoLve.png'
            },
            {
                title: {
                    zh: '餐饮服务',
                    en: 'Office Use',
                    ja: 'オフィス使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '可用于餐厅、咖啡厅等场所',
                    en: 'Suitable for use in offices and conference rooms',
                    ja: 'オフィスや会議室などで使用に適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ChouZhiCanYin.png'
            },
            {
                title: {
                    zh: '商务会议接待',
                    en: 'Food Service',
                    ja: 'フードサービス',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适合办公室、会议室等场所定制化使用',
                    en: 'Can be used in restaurants and cafes',
                    ja: 'レストランやカフェなどで使用できます',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ChouZhiShangWuHuiYi.png'
            }
        ],
        relatedProducts: ['finishedpaper-004', 'finishedpaper-010', 'finishedpaper-006']
    },
    {
        id: 'finishedpaper-006',
        title: { zh: '“一鹿有您”软抽', en: 'Zhuyun 185 Soft Tissue', ja: 'ジュヨンイチハイロウルチョウ', Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ' },
        category: 'finishedpaper',
        desc: { zh: '原生竹浆，绿色健康', en: 'Virgin bamboo pulp, green and healthy', ja: 'バージンバンブーパルプ、緑と健康です。', Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ' },
        img: '/images/finishedPaper/YiLuYouNinRuanChouSuoLve.png',
        gallery: ['/images/finishedPaper/YiLuYouNinRuanChouSuoLve.png'],
        features: { zh: ['100%原生竹浆制造','超强吸水性能','柔软亲肤','环保可降解','无荧光剂添加'], en: ['Virgin bamboo pulp', 'Green and healthy'], ja: ['バージンバンブーパルプ', '緑と健康です。'],Russian: ['バージンバンブーパルプ', '緑と健康です。'],Malay: ['バージンバンブーパルプ', '緑と健康です。']  },
        certifications: [{icon:'fa-certificate',name:{zh:'ISO9001认证',en:'ISO9001 Certification',ja:'ISO9001認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-leaf',name:{zh:'FSC认证',en:'FSC Certification',ja:'FSC認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-shield-alt',name:{zh:'食品级认证',en:'Food Grade Certification',ja:'食品レベル認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}}],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '竹浆本色',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '原生竹浆',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '134mmx190mm',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Layers',
                    ja: '層数',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '3层',
                    en: '3 layers',
                    ja: '3層',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '100抽',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '小鹿系列',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '干湿两用',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: 'T/SCSZX 002',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '指导价',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '2.88元/包 ',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '家庭日常',
                    en: 'Home Daily Use',
                    ja: 'ホームデイリー使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适用于家庭日常清洁、擦拭等用途',
                    en: 'Suitable for daily cleaning and wiping in households',
                    ja: 'ホームデイリーでのクリーニングとワイプに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/JiaTingShengHuoSuoLve.png'
            },
            {
                title: {
                    zh: '餐饮服务',
                    en: 'Office Use',
                    ja: 'オフィス使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '可用于餐厅、咖啡厅等场所',
                    en: 'Suitable for use in offices and conference rooms',
                    ja: 'オフィスや会議室などで使用に適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ChouZhiCanYin.png'
            },
            {
                title: {
                    zh: '商务会议接待',
                    en: 'Food Service',
                    ja: 'フードサービス',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适合办公室、会议室等场所定制化使用',
                    en: 'Can be used in restaurants and cafes',
                    ja: 'レストランやカフェなどで使用できます',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ChouZhiShangWuHuiYi.png'
            }
        ],
        relatedProducts: ['finishedpaper-007', 'finishedpaper-015', 'finishedpaper-012']
    },
    {
        id: 'finishedpaper-007',
        title: { zh: '“莫迪卡”软抽135', en: 'Zhuyun 185 Soft Tissue', ja: 'ジュヨンイチハイロウルチョウ', Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ' },
        category: 'finishedpaper',
        desc: { zh: '原生竹浆，绿色健康', en: 'Virgin bamboo pulp, green and healthy', ja: 'バージンバンブーパルプ、緑と健康です。', Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ' },
        img: '/images/finishedPaper/MoDiKaRuanChou135.png',
        gallery: ['/images/finishedPaper/MoDiKaRuanChou135.png'],
        features: { zh: ['100%原生竹浆制造','超强吸水性能','柔软亲肤','环保可降解','无荧光剂添加'], en: ['Virgin bamboo pulp', 'Green and healthy'], ja: ['バージンバンブーパルプ', '緑と健康です。'], Russian: ['バージンバンブーパルプ', '緑と健康です。'] , Malay: ['バージンバンブーパルプ', '緑と健康です。']   },
        certifications: [{icon:'fa-certificate',name:{zh:'ISO9001认证',en:'ISO9001 Certification',ja:'ISO9001認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-leaf',name:{zh:'FSC认证',en:'FSC Certification',ja:'FSC認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-shield-alt',name:{zh:'食品级认证',en:'Food Grade Certification',ja:'食品レベル認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}}],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '竹浆本色',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '原生竹浆',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '135mmx190mm',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Layers',
                    ja: '層数',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '3层',
                    en: '3 layers',
                    ja: '3層',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '120抽',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '莫迪卡系列',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '干湿两用',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: 'GB/T 20808',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '指导价',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '2.48元/包 ',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '家庭日常',
                    en: 'Home Daily Use',
                    ja: 'ホームデイリー使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适用于家庭日常清洁、擦拭等用途',
                    en: 'Suitable for daily cleaning and wiping in households',
                    ja: 'ホームデイリーでのクリーニングとワイプに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/JiaTingShengHuoSuoLve.png'
            },
            {
                title: {
                    zh: '餐饮服务',
                    en: 'Office Use',
                    ja: 'オフィス使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '可用于餐厅、咖啡厅等场所',
                    en: 'Suitable for use in offices and conference rooms',
                    ja: 'オフィスや会議室などで使用に適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ChouZhiCanYin.png'
            },
            {
                title: {
                    zh: '商务会议接待',
                    en: 'Food Service',
                    ja: 'フードサービス',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适合办公室、会议室等场所定制化使用',
                    en: 'Can be used in restaurants and cafes',
                    ja: 'レストランやカフェなどで使用できます',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ChouZhiShangWuHuiYi.png'
            }
        ],
        relatedProducts: ['finishedpaper-015', 'finishedpaper-006', 'finishedpaper-012']
    },
    {
        id: 'finishedpaper-008',
        title: { zh: '山水可湿水盒抽', en: 'Zhuyun 185 Soft Tissue', ja: 'ジュヨンイチハイロウルチョウ', Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ' },
        category: 'finishedpaper',
        desc: { zh: '原生竹浆，绿色健康', en: 'Virgin bamboo pulp, green and healthy', ja: 'バージンバンブーパルプ、緑と健康です。' , Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ'},
        img: '/images/finishedPaper/ShanShuiKeShiShuiHeChouSuoLve.png',
        gallery: ['/images/finishedPaper/ShanShuiKeShiShuiHeChouSuoLve.png'],
        features: { zh: ['100%原生竹浆制造','超强吸水性能','柔软亲肤','环保可降解','无荧光剂添加'], en: ['Virgin bamboo pulp', 'Green and healthy'], ja: ['バージンバンブーパルプ', '緑と健康です。'] , Russian: ['バージンバンブーパルプ', '緑と健康です。'] , Malay: ['バージンバンブーパルプ', '緑と健康です。']  },
        certifications: [{icon:'fa-certificate',name:{zh:'ISO9001认证',en:'ISO9001 Certification',ja:'ISO9001認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-leaf',name:{zh:'FSC认证',en:'FSC Certification',ja:'FSC認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-shield-alt',name:{zh:'食品级认证',en:'Food Grade Certification',ja:'食品レベル認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}}],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '竹浆本色',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '原生竹浆',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '185mm x 190mm',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Layers',
                    ja: '層数',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '3层',
                    en: '3 layers',
                    ja: '3層',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '120抽',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '山水系列（可根据需求定制）',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '干湿两用',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: 'GB/T 20808',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '指导价',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '7.5元/盒 ',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '商务接待',
                    en: 'Food Service',
                    ja: 'フードサービス',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适合商务接待等场所定制化使用',
                    en: 'Can be used in restaurants and cafes',
                    ja: 'レストランやカフェなどで使用できます',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ChouZhiShangWuHuiYi.png'
            },
            {
                title: {
                    zh: '办公会议',
                    en: 'Office Use',
                    ja: 'オフィス使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '可用于办公室、会议室等场所',
                    en: 'Suitable for use in offices and conference rooms',
                    ja: 'オフィスや会議室などで使用に適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ChouZhiHuiYiBanGong.png'
            },
            {
                title: {
                    zh: '酒店定制',
                    en: 'Food Service',
                    ja: 'フードサービス',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适合酒店等场所定制化使用',
                    en: 'Can be used in restaurants and cafes',
                    ja: 'レストランやカフェなどで使用できます',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ChouZhiJiuDian.png'
            }
        ],
        relatedProducts: ['finishedpaper-001', 'finishedpaper-009', 'finishedpaper-013']
    },
    {
        id: 'finishedpaper-009',
        title: { zh: '山水可湿水条巾纸', en: 'Zhuyun 185 Soft Tissue', ja: 'ジュヨンイチハイロウルチョウ', Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ' },
        category: 'finishedpaper',
        desc: { zh: '原生竹浆，绿色健康', en: 'Virgin bamboo pulp, green and healthy', ja: 'バージンバンブーパルプ、緑と健康です。', Russian: 'バージンバンブーパルプ、緑と健康です。', Malay: 'バージンバンブーパルプ、緑と健康です。' },
        img: '/images/finishedPaper/ShanShuiKeShiShuiTiaoJinZhiSuoLve.png',
        gallery: ['/images/finishedPaper/ShanShuiKeShiShuiTiaoJinZhiSuoLve.png'],
        features: { zh: ['100%原生竹浆制造','超强吸水性能','柔软亲肤','环保可降解','包装小巧，方便携带'], en: ['Virgin bamboo pulp', 'Green and healthy'], ja: ['バージンバンブーパルプ', '緑と健康です。'] , Russian: ['バージンバンブーパルプ', '緑と健康です。'], Malay: ['バージンバンブーパルプ', '緑と健康です。'] },
        certifications: [{icon:'fa-certificate',name:{zh:'ISO9001认证',en:'ISO9001 Certification',ja:'ISO9001認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-leaf',name:{zh:'FSC认证',en:'FSC Certification',ja:'FSC認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-shield-alt',name:{zh:'食品级认证',en:'Food Grade Certification',ja:'食品レベル認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}}],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '竹浆本色',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '原生竹浆',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '200mm x 200mm',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Layers',
                    ja: '層数',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '3层',
                    en: '3 layers',
                    ja: '3層',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '12片',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '山水系列',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '干湿两用',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: 'GB/T 20810',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '指导价',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '1.5元/包 ',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '商务会议',
                    en: 'Food Service',
                    ja: 'フードサービス',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适合商务会议等场所定制化使用',
                    en: 'Can be used in restaurants and cafes',
                    ja: 'レストランやカフェなどで使用できます',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/TiaoJinZhiShangWuHuiYi.png'
            },
            {
                title: {
                    zh: '出差便携',
                    en: 'Office Use',
                    ja: 'オフィス使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '可用于出差、机场高铁站等场所便携使用',
                    en: 'Suitable for use in offices and conference rooms',
                    ja: 'オフィスや会議室などで使用に適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/TiaoJinZhiChuChai.png'
            },
            {
                title: {
                    zh: '旅游便携',
                    en: 'Food Service',
                    ja: 'フードサービス',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适合旅游、露营等便携使用',
                    en: 'Can be used in restaurants and cafes',
                    ja: 'レストランやカフェなどで使用できます',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/TiaoJinZhiLuYou.png'
            }
        ],
        relatedProducts: ['finishedpaper-001', 'finishedpaper-008', 'finishedpaper-013']
    },
    {
        id: 'finishedpaper-010',
        title: { zh: '哪吒条巾纸', en: 'Zhuyun 185 Soft Tissue', ja: 'ジュヨンイチハイロウルチョウ', Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ' },
        category: 'finishedpaper',
        desc: { zh: '原生竹浆，绿色健康', en: 'Virgin bamboo pulp, green and healthy', ja: 'バージンバンブーパルプ、緑と健康です。', Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ' },
        img: '/images/finishedPaper/NeZhaTiaoJinZhiSuoLve.png',
        gallery: ['/images/finishedPaper/NeZhaTiaoJinZhiSuoLve.png'],
        features: { zh: ['100%原生竹浆制造','超强吸水性能','柔软亲肤','环保可降解','包装小巧，方便携带'], en: ['Virgin bamboo pulp', 'Green and healthy'], ja: ['バージンバンブーパルプ', '緑と健康です。'], Russian: ['バージンバンブーパルプ', '緑と健康です。'], Malay: ['バージンバンブーパルプ', '緑と健康です。']  },
        certifications: [{icon:'fa-certificate',name:{zh:'ISO9001认证',en:'ISO9001 Certification',ja:'ISO9001認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-leaf',name:{zh:'FSC认证',en:'FSC Certification',ja:'FSC認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-shield-alt',name:{zh:'食品级认证',en:'Food Grade Certification',ja:'食品レベル認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}}],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '竹浆本色',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '原生竹浆',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '200mm x 200mm',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Layers',
                    ja: '層数',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '3层',
                    en: '3 layers',
                    ja: '3層',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '12片',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '哪吒系列',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '干湿两用',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: 'GB/T 20810',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '指导价',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '1.5元/包 ',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '商务会议',
                    en: 'Food Service',
                    ja: 'フードサービス',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适合商务会议等场所定制化使用',
                    en: 'Can be used in restaurants and cafes',
                    ja: 'レストランやカフェなどで使用できます',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/TiaoJinZhiShangWuHuiYi.png'
            },
            {
                title: {
                    zh: '出差便携',
                    en: 'Office Use',
                    ja: 'オフィス使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '可用于出差、机场高铁站等场所便携使用',
                    en: 'Suitable for use in offices and conference rooms',
                    ja: 'オフィスや会議室などで使用に適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/TiaoJinZhiChuChai.png'
            },
            {
                title: {
                    zh: '旅游便携',
                    en: 'Food Service',
                    ja: 'フードサービス',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适合旅游、露营等便携使用',
                    en: 'Can be used in restaurants and cafes',
                    ja: 'レストランやカフェなどで使用できます',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/TiaoJinZhiLuYou.png'
            }
        ],
        relatedProducts: ['finishedpaper-004', 'finishedpaper-005', 'finishedpaper-012']
    },
    {
        id: 'finishedpaper-011',
        title: { zh: '竹韵手帕纸', en: 'Zhuyun 185 Soft Tissue', ja: 'ジュヨンイチハイロウルチョウ', Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ' },
        category: 'finishedpaper',
        desc: { zh: '原生竹浆，绿色健康', en: 'Virgin bamboo pulp, green and healthy', ja: 'バージンバンブーパルプ、緑と健康です。', Russian: 'バージンバンブーパルプ、緑と健康です。', Malay: 'バージンバンブーパルプ、緑と健康です。' },
        img: '/images/finishedPaper/ZhuYunShouPaZhi.png',
        gallery: ['/images/finishedPaper/ZhuYunShouPaZhi.png'],
        features: { zh: ['100%原生竹浆制造','超强吸水性能','柔软亲肤','环保可降解','包装小巧，方便携带'], en: ['Virgin bamboo pulp', 'Green and healthy'], ja: ['バージンバンブーパルプ', '緑と健康です。'], Russian: ['バージンバンブーパルプ', '緑と健康です。'], Malay: ['バージンバンブーパルプ', '緑と健康です。']  },
        certifications: [{icon:'fa-certificate',name:{zh:'ISO9001认证',en:'ISO9001 Certification',ja:'ISO9001認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-leaf',name:{zh:'FSC认证',en:'FSC Certification',ja:'FSC認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-shield-alt',name:{zh:'食品级认证',en:'Food Grade Certification',ja:'食品レベル認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}}],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '竹浆本色',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '原生竹浆',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '210mm x 210mm',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Layers',
                    ja: '層数',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '4层',
                    en: '3 layers',
                    ja: '3層',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '12片',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '竹韵系列',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '干湿两用',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: 'T/SCSZX 002',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '指导价',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '0.75元/包 ',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '商务会议',
                    en: 'Food Service',
                    ja: 'フードサービス',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适合商务会议等场所定制化使用',
                    en: 'Can be used in restaurants and cafes',
                    ja: 'レストランやカフェなどで使用できます',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/TiaoJinZhiShangWuHuiYi.png'
            },
            {
                title: {
                    zh: '出差便携',
                    en: 'Office Use',
                    ja: 'オフィス使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '可用于出差、机场高铁站等场所便携使用',
                    en: 'Suitable for use in offices and conference rooms',
                    ja: 'オフィスや会議室などで使用に適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/TiaoJinZhiChuChai.png'
            },
            {
                title: {
                    zh: '旅游便携',
                    en: 'Food Service',
                    ja: 'フードサービス',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适合旅游、露营等便携使用',
                    en: 'Can be used in restaurants and cafes',
                    ja: 'レストランやカフェなどで使用できます',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/TiaoJinZhiLuYou.png'
            }
        ],
        relatedProducts: ['finishedpaper-002', 'finishedpaper-003', 'finishedpaper-014']
    },
    {
        id: 'finishedpaper-012',
        title: { zh: '“花样年华"条巾纸', en: 'Zhuyun 185 Soft Tissue', ja: 'ジュヨンイチハイロウルチョウ', Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ' },
        category: 'finishedpaper',
        desc: { zh: '原生竹浆，绿色健康', en: 'Virgin bamboo pulp, green and healthy', ja: 'バージンバンブーパルプ、緑と健康です。', Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ' },
        img: '/images/finishedPaper/HuaYangNianHuaTiaoJinZhiSuoLve.png',
        gallery: ['/images/finishedPaper/HuaYangNianHuaTiaoJinZhiSuoLve.png'],
        features: { zh: ['100%原生竹浆制造','超强吸水性能','柔软亲肤','环保可降解','包装小巧，方便携带'], en: ['Virgin bamboo pulp', 'Green and healthy'], ja: ['バージンバンブーパルプ', '緑と健康です。'], Russian: ['バージンバンブーパルプ', '緑と健康です。'], Malay: ['バージンバンブーパルプ', '緑と健康です。']  },
        certifications: [{icon:'fa-certificate',name:{zh:'ISO9001认证',en:'ISO9001 Certification',ja:'ISO9001認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-leaf',name:{zh:'FSC认证',en:'FSC Certification',ja:'FSC認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-shield-alt',name:{zh:'食品级认证',en:'Food Grade Certification',ja:'食品レベル認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}}],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '竹浆本色',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '原生竹浆',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '200mm x 200mm',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Layers',
                    ja: '層数',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '3层',
                    en: '3 layers',
                    ja: '3層',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '12片',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '经典系列',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '干湿两用',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: 'T/SCSZX 002',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '指导价',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '1元/包 ',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '商务会议',
                    en: 'Food Service',
                    ja: 'フードサービス',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适合商务会议等场所定制化使用',
                    en: 'Can be used in restaurants and cafes',
                    ja: 'レストランやカフェなどで使用できます',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/TiaoJinZhiShangWuHuiYi.png'
            },
            {
                title: {
                    zh: '出差便携',
                    en: 'Office Use',
                    ja: 'オフィス使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '可用于出差、机场高铁站等场所便携使用',
                    en: 'Suitable for use in offices and conference rooms',
                    ja: 'オフィスや会議室などで使用に適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/TiaoJinZhiChuChai.png'
            },
            {
                title: {
                    zh: '旅游便携',
                    en: 'Food Service',
                    ja: 'フードサービス',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适合旅游、露营等便携使用',
                    en: 'Can be used in restaurants and cafes',
                    ja: 'レストランやカフェなどで使用できます',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/TiaoJinZhiLuYou.png'
            }
        ],
        relatedProducts: ['finishedpaper-009', 'finishedpaper-010', 'finishedpaper-011']
    },
    {
        id: 'finishedpaper-013',
        title: { zh: '山水速溶卷纸', en: 'Zhuyun 185 Soft Tissue', ja: 'ジュヨンイチハイロウルチョウ', Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ' },
        category: 'finishedpaper',
        desc: { zh: '原生竹浆，绿色健康', en: 'Virgin bamboo pulp, green and healthy', ja: 'バージンバンブーパルプ、緑と健康です。', Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ' },
        img: '/images/finishedPaper/ShanShuiSuRongJuanZhiSuoLve.png',
        gallery: ['/images/finishedPaper/ShanShuiSuRongJuanZhiSuoLve.png'],
        features: { zh: ['100%原生竹浆制造','柔软亲肤','环保可降解','冲水速溶'], en: ['Virgin bamboo pulp', 'Green and healthy'], ja: ['バージンバンブーパルプ', '緑と健康です。'] , Russian: ['バージンバンブーパルプ', '緑と健康です。'] , Malay: ['バージンバンブーパルプ', '緑と健康です。']  },
        certifications: [{icon:'fa-certificate',name:{zh:'ISO9001认证',en:'ISO9001 Certification',ja:'ISO9001認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-leaf',name:{zh:'FSC认证',en:'FSC Certification',ja:'FSC認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-shield-alt',name:{zh:'食品级认证',en:'Food Grade Certification',ja:'食品レベル認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}}],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '竹浆本色',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '原生竹浆',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '108mm x 138mm/节',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Layers',
                    ja: '層数',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '4层',
                    en: '3 layers',
                    ja: '3層',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '山水系列',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '冲水速溶',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: 'GB/T 20810',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '指导价',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '3.5元/卷 ',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '洗手间清洁',
                    en: 'Home Daily Use',
                    ja: 'ホームデイリー使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适用于厕所、洗手间日常清洁擦拭等用途',
                    en: 'Suitable for daily cleaning and wiping in households',
                    ja: 'ホームデイリーでのクリーニングとワイプに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/JuanZhiCeSuo.png'
            },
            {
                title: {
                    zh: '个人卫生清洁',
                    en: 'Office Use',
                    ja: 'オフィス使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '可用于个人卫生清洁',
                    en: 'Suitable for use in offices and conference rooms',
                    ja: 'オフィスや会議室などで使用に適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/JuanZhiGeRenQingJie.png'
            }
        ],
        relatedProducts: ['finishedpaper-001', 'finishedpaper-008', 'finishedpaper-009']
    },
    {
        id: 'finishedpaper-014',
        title: { zh: '竹韵无芯卷纸', en: 'Zhuyun 185 Soft Tissue', ja: 'ジュヨンイチハイロウルチョウ', Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ' },
        category: 'finishedpaper',
        desc: { zh: '原生竹浆，绿色健康', en: 'Virgin bamboo pulp, green and healthy', ja: 'バージンバンブーパルプ、緑と健康です。', Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ' },
        img: '/images/finishedPaper/ZhuYunWuXinJuanZhiSuoLve.png',
        gallery: ['/images/finishedPaper/ZhuYunWuXinJuanZhiSuoLve.png'],
        features: { zh: ['100%原生竹浆制造','柔软亲肤','环保可降解','冲水速溶'], en: ['Virgin bamboo pulp', 'Green and healthy'], ja: ['バージンバンブーパルプ', '緑と健康です。'], Russian: ['バージンバンブーパルプ', '緑と健康です。'], Malay: ['バージンバンブーパルプ', '緑と健康です。']  },
        certifications: [{icon:'fa-certificate',name:{zh:'ISO9001认证',en:'ISO9001 Certification',ja:'ISO9001認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-leaf',name:{zh:'FSC认证',en:'FSC Certification',ja:'FSC認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-shield-alt',name:{zh:'食品级认证',en:'Food Grade Certification',ja:'食品レベル認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}}],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '竹浆本色',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '原生竹浆',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '108mm x 138mm/节',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Layers',
                    ja: '層数',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '4层',
                    en: '3 layers',
                    ja: '3層',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '竹韵系列',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '冲水速溶',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: 'T/SCSZX 002',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '指导价',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '3.1元/卷 ',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '洗手间清洁',
                    en: 'Home Daily Use',
                    ja: 'ホームデイリー使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适用于厕所、洗手间日常清洁擦拭等用途',
                    en: 'Suitable for daily cleaning and wiping in households',
                    ja: 'ホームデイリーでのクリーニングとワイプに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/JuanZhiCeSuo.png'
            },
            {
                title: {
                    zh: '个人卫生清洁',
                    en: 'Office Use',
                    ja: 'オフィス使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '可用于个人卫生清洁',
                    en: 'Suitable for use in offices and conference rooms',
                    ja: 'オフィスや会議室などで使用に適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/JuanZhiGeRenQingJie.png'
            }
        ],
        relatedProducts: ['finishedpaper-002', 'finishedpaper-003', 'finishedpaper-011']
    },
    {
        id: 'finishedpaper-015',
        title: { zh: '“莫迪卡”卷纸', en: 'Zhuyun 185 Soft Tissue', ja: 'ジュヨンイチハイロウルチョウ', Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ' },
        category: 'finishedpaper',
        desc: { zh: '原生竹浆，绿色健康', en: 'Virgin bamboo pulp, green and healthy', ja: 'バージンバンブーパルプ、緑と健康です。', Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ' },
        img: '/images/finishedPaper/MoDiKaJuanZhi.png',
        gallery: ['/images/finishedPaper/MoDiKaJuanZhi.png'],
        features: { zh: ['100%原生竹浆制造','柔软亲肤','环保可降解','冲水速溶'], en: ['Virgin bamboo pulp', 'Green and healthy'], ja: ['バージンバンブーパルプ', '緑と健康です。'], Russian: ['バージンバンブーパルプ', '緑と健康です。'], Malay: ['バージンバンブーパルプ', '緑と健康です。']  },
        certifications: [{icon:'fa-certificate',name:{zh:'ISO9001认证',en:'ISO9001 Certification',ja:'ISO9001認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-leaf',name:{zh:'FSC认证',en:'FSC Certification',ja:'FSC認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-shield-alt',name:{zh:'食品级认证',en:'Food Grade Certification',ja:'食品レベル認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}}],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '竹浆本色',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '原生竹浆',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '108mm x 138mm/节',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Layers',
                    ja: '層数',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '4层',
                    en: '3 layers',
                    ja: '3層',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '莫迪卡系列',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '冲水速溶',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: 'GB/T 20810',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '指导价',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '3.1元/卷 ',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '洗手间清洁',
                    en: 'Home Daily Use',
                    ja: 'ホームデイリー使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适用于厕所、洗手间日常清洁擦拭等用途',
                    en: 'Suitable for daily cleaning and wiping in households',
                    ja: 'ホームデイリーでのクリーニングとワイプに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/JuanZhiCeSuo.png'
            },
            {
                title: {
                    zh: '个人卫生清洁',
                    en: 'Office Use',
                    ja: 'オフィス使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '可用于个人卫生清洁',
                    en: 'Suitable for use in offices and conference rooms',
                    ja: 'オフィスや会議室などで使用に適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/JuanZhiGeRenQingJie.png'
            }
        ],
        relatedProducts: ['finishedpaper-007', 'finishedpaper-013', 'finishedpaper-014']
    },
    {
        id: 'finishedpaper-016',
        title: { zh: '厨房抽纸', en: 'Zhuyun 185 Soft Tissue', ja: 'ジュヨンイチハイロウルチョウ', Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ' },
        category: 'finishedpaper',
        desc: { zh: '原生竹浆，绿色健康', en: 'Virgin bamboo pulp, green and healthy', ja: 'バージンバンブーパルプ、緑と健康です。', Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ' },
        img: '/images/finishedPaper/ChuFangChouZhiSuoLve.png',
        gallery: ['/images/finishedPaper/ChuFangChouZhiSuoLve.png'],
        features: { zh: ['100%原生竹浆制造','不漂白、无荧光','七大油污双倍洁净','擦碗擦桌不掉渣'], en: ['Virgin bamboo pulp', 'Green and healthy'], ja: ['バージンバンブーパルプ', '緑と健康です。'], Russian: ['バージンバンブーパルプ', '緑と健康です。'], Malay: ['バージンバンブーパルプ', '緑と健康です。']  },
        certifications: [{icon:'fa-certificate',name:{zh:'ISO9001认证',en:'ISO9001 Certification',ja:'ISO9001認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-leaf',name:{zh:'FSC认证',en:'FSC Certification',ja:'FSC認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-shield-alt',name:{zh:'食品级认证',en:'Food Grade Certification',ja:'食品レベル認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}}],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '竹浆本色',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '原生竹浆',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '198mm x 210mm',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Layers',
                    ja: '層数',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '2层',
                    en: '3 layers',
                    ja: '3層',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '80抽',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '厨卫系列',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '吸油吸水',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: 'T/SCSZX 002',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '指导价',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '6元/包  ',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '厨房使用',
                    en: 'Home Daily Use',
                    ja: 'ホームデイリー使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适用于厨房日常清洁、擦拭等用途',
                    en: 'Suitable for daily cleaning and wiping in households',
                    ja: 'ホームデイリーでのクリーニングとワイプに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ChuFangChouZhiChuFang.png'
            },
            {
                title: {
                    zh: '餐饮服务',
                    en: 'Office Use',
                    ja: 'オフィス使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '可用于餐厅、咖啡厅等场所',
                    en: 'Suitable for use in offices and conference rooms',
                    ja: 'オフィスや会議室などで使用に適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ChouZhiCanYin.png'
            },
            {
                title: {
                    zh: '酒店定制',
                    en: 'Food Service',
                    ja: 'フードサービス',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适合酒店等场所定制化使用',
                    en: 'Can be used in restaurants and cafes',
                    ja: 'レストランやカフェなどで使用できます',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ChouZhiJiuDian.png'
            }
        ],
        relatedProducts: ['finishedpaper-017', 'finishedpaper-018', 'finishedpaper-019']
    },
    {
        id: 'finishedpaper-017',
        title: { zh: '小盘纸', en: 'Zhuyun 185 Soft Tissue', ja: 'ジュヨンイチハイロウルチョウ', Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ' },
        category: 'finishedpaper',
        desc: { zh: '原生竹浆，绿色健康', en: 'Virgin bamboo pulp, green and healthy', ja: 'バージンバンブーパルプ、緑と健康です。' , Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ'},
        img: '/images/finishedPaper/XiaoPanZhiSuoLve.png',
        gallery: ['/images/finishedPaper/XiaoPanZhiSuoLve.png'],
        features: { zh: ['100%原生竹浆制造','符合FSC认证','不堵厕所','冲水速溶'], en: ['Virgin bamboo pulp', 'Green and healthy'], ja: ['バージンバンブーパルプ', '緑と健康です。'] , Russian: ['バージンバンブーパルプ', '緑と健康です。'] , Malay: ['バージンバンブーパルプ', '緑と健康です。']  },
        certifications: [{icon:'fa-certificate',name:{zh:'ISO9001认证',en:'ISO9001 Certification',ja:'ISO9001認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-leaf',name:{zh:'FSC认证',en:'FSC Certification',ja:'FSC認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}}],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '竹浆本色',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '原生竹浆',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '94mm x 120mm',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Layers',
                    ja: '層数',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '3层',
                    en: '3 layers',
                    ja: '3層',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '1380节',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '厨卫系列',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '吸水性强',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: 'T/SCSZX 002',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '指导价',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '13.6元/卷   ',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '公共卫生间',
                    en: 'Home Daily Use',
                    ja: 'ホームデイリー使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适用于公共卫生间区域、厕所等',
                    en: 'Suitable for daily cleaning and wiping in households',
                    ja: 'ホームデイリーでのクリーニングとワイプに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/XiaoPanZhiCeSuo.png'
            }
        ],
        relatedProducts: ['finishedpaper-016', 'finishedpaper-018', 'finishedpaper-019']
    },
    {
        id: 'finishedpaper-018',
        title: { zh: '擦手纸', en: 'Zhuyun 185 Soft Tissue', ja: 'ジュヨンイチハイロウルチョウ', Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ' },
        category: 'finishedpaper',
        desc: { zh: '原生竹浆，绿色健康', en: 'Virgin bamboo pulp, green and healthy', ja: 'バージンバンブーパルプ、緑と健康です。', Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ'  },
        img: '/images/finishedPaper/CaShouZhiSuoLve.png',
        gallery: ['/images/finishedPaper/CaShouZhiSuoLve.png'],
        features: { zh: ['100%原生竹浆制造','符合FSC认证','吸水性强','不掉渣不掉屑'], en: ['Virgin bamboo pulp', 'Green and healthy'], ja: ['バージンバンブーパルプ', '緑と健康です。'] , Russian: ['バージンバンブーパルプ', '緑と健康です。'], Malay: ['バージンバンブーパルプ', '緑と健康です。'] },
        certifications: [{icon:'fa-certificate',name:{zh:'ISO9001认证',en:'ISO9001 Certification',ja:'ISO9001認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-leaf',name:{zh:'FSC认证',en:'FSC Certification',ja:'FSC認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}}],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '竹浆本色',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '原生竹浆',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '225mm x 225mm',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Layers',
                    ja: '層数',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '1层',
                    en: '3 layers',
                    ja: '3層',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '200张',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '厨卫系列',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '吸水性强',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: 'T/SCSZX 002',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '指导价',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '7.6元/包',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '卫生间',
                    en: 'Home Daily Use',
                    ja: 'ホームデイリー使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适用于卫生间区域、厕所等',
                    en: 'Suitable for daily cleaning and wiping in households',
                    ja: 'ホームデイリーでのクリーニングとワイプに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/CaShouZhiCeSuo.png'
            }
        ],
        relatedProducts: ['finishedpaper-016', 'finishedpaper-017', 'finishedpaper-019']
    },
    {
        id: 'finishedpaper-019',
        title: { zh: '亲肤棉柔巾', en: 'Zhuyun 185 Soft Tissue', ja: 'ジュヨンイチハイロウルチョウ', Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ' },
        category: 'finishedpaper',
        desc: { zh: '富含竹纤维，超强吸水', en: 'Virgin bamboo pulp, green and healthy', ja: 'バージンバンブーパルプ、緑と健康です。', Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ' },
        img: '/images/finishedPaper/QinFuMianRouJinSuoLve.png',
        gallery: ['/images/finishedPaper/QinFuMianRouJinSuoLve.png'],
        features: { zh: ['富含竹纤维','超强吸水','干湿两用','亲肤柔软'], en: ['Virgin bamboo pulp', 'Green and healthy'], ja: ['バージンバンブーパルプ', '緑と健康です。'] , Russian: ['バージンバンブーパルプ', '緑と健康です。'] , Malay: ['バージンバンブーパルプ', '緑と健康です。']  },
        certifications: [{icon:'fa-certificate',name:{zh:'ISO9001认证',en:'ISO9001 Certification',ja:'ISO9001認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-leaf',name:{zh:'FSC认证',en:'FSC Certification',ja:'FSC認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}}],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '白色',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '竹纤维',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '200mm x 200mm',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Layers',
                    ja: '層数',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '1层',
                    en: '3 layers',
                    ja: '3層',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '60张',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '竹纤维系列',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '卸妆、可代替洗脸巾',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: 'GB/T40276',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '指导价',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '16.9元/包',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '个人清洁',
                    en: 'Home Daily Use',
                    ja: 'ホームデイリー使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适用于个人日常清洁、擦拭等用途',
                    en: 'Suitable for daily cleaning and wiping in households',
                    ja: 'ホームデイリーでのクリーニングとワイプに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/GeRenQingJie.png'
            },
            {
                title: {
                    zh: '卸妆',
                    en: 'Office Use',
                    ja: 'オフィス使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '可用于卸妆',
                    en: 'Suitable for use in offices and conference rooms',
                    ja: 'オフィスや会議室などで使用に適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/XieZhuang.png'
            },
            {
                title: {
                    zh: '洗脸巾替代',
                    en: 'Food Service',
                    ja: 'フードサービス',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '可用于代替洗脸巾',
                    en: 'Can be used in restaurants and cafes',
                    ja: 'レストランやカフェなどで使用できます',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/XiLianJinTiDai.png'
            }
        ],
        relatedProducts: ['finishedpaper-020', 'finishedpaper-021', 'finishedpaper-022']
    },
    {
        id: 'finishedpaper-020',
        title: { zh: '竹纤维婴儿柔肤湿纸巾', en: 'Zhuyun 185 Soft Tissue', ja: 'ジュヨンイチハイロウルチョウ', Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ' },
        category: 'finishedpaper',
        desc: { zh: '富含竹纤维，温和不刺激', en: 'Virgin bamboo pulp, green and healthy', ja: 'バージンバンブーパルプ、緑と健康です。', Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ' },
        img: '/images/finishedPaper/ZhuXianWeiYingErRouFuShiZhiJinSuoLve.png',
        gallery: ['/images/finishedPaper/ZhuXianWeiYingErRouFuShiZhiJinSuoLve.png'],
        features: { zh: ['富含竹纤维','温和不刺激','宝宝放心用','亲肤柔软'], en: ['Virgin bamboo pulp', 'Green and healthy'], ja: ['バージンバンブーパルプ', '緑と健康です。'], Russian: ['バージンバンブーパルプ', '緑と健康です。'], Malay: ['バージンバンブーパルプ', '緑と健康です。']  },
        certifications: [{icon:'fa-certificate',name:{zh:'ISO9001认证',en:'ISO9001 Certification',ja:'ISO9001認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-leaf',name:{zh:'FSC认证',en:'FSC Certification',ja:'FSC認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}}],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '白色',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '竹纤维',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '180mm x 180mm',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Layers',
                    ja: '層数',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '1层',
                    en: '3 layers',
                    ja: '3層',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '80张',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '竹纤维系列',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '深层清洁、可降解',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: 'GB/T27728',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '指导价',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '12.9元/包',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '母婴适用',
                    en: 'Home Daily Use',
                    ja: 'ホームデイリー使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适用于母婴日常清洁、擦拭等用途',
                    en: 'Suitable for daily cleaning and wiping in households',
                    ja: 'ホームデイリーでのクリーニングとワイプに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/MuYing.png'
            },
            {
                title: {
                    zh: '敏感肌',
                    en: 'Home Daily Use',
                    ja: 'ホームデイリー使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适用于敏感肌人群日常清洁、擦拭等用途',
                    en: 'Suitable for daily cleaning and wiping in households',
                    ja: 'ホームデイリーでのクリーニングとワイプに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/MinGanJi.png'
            }
        ],
        relatedProducts: ['finishedpaper-019', 'finishedpaper-021', 'finishedpaper-022']
    },
    {
        id: 'finishedpaper-021',
        title: { zh: '竹纤维湿厕纸', en: 'Zhuyun 185 Soft Tissue', ja: 'ジュヨンイチハイロウルチョウ', Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ' },
        category: 'finishedpaper',
        desc: { zh: '富含竹纤维，母婴级呵护', en: 'Virgin bamboo pulp, green and healthy', ja: 'バージンバンブーパルプ、緑と健康です。', Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ' },
        img: '/images/finishedPaper/ZhuXianWeiShiCeZhi.png',
        gallery: ['/images/finishedPaper/ZhuXianWeiShiCeZhi.png'],
        features: { zh: ['富含竹纤维','可降解','亲肤、抗菌、柔韧','母婴级呵护'], en: ['Virgin bamboo pulp', 'Green and healthy'], ja: ['バージンバンブーパルプ', '緑と健康です。'], Russian: ['バージンバンブーパルプ', '緑と健康です。'], Malay: ['バージンバンブーパルプ', '緑と健康です。']  },
        certifications: [{icon:'fa-certificate',name:{zh:'ISO9001认证',en:'ISO9001 Certification',ja:'ISO9001認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-leaf',name:{zh:'FSC认证',en:'FSC Certification',ja:'FSC認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}}],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '白色',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '竹纤维',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '150mm x 200mm',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Layers',
                    ja: '層数',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '1层',
                    en: '3 layers',
                    ja: '3層',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '80张',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '竹纤维系列',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '深层清洁、可降解',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: 'GB/T27728',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '指导价',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '14.9元/包',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '厕所使用',
                    en: 'Home Daily Use',
                    ja: 'ホームデイリー使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适用于个人清洁、擦拭等用途',
                    en: 'Suitable for daily cleaning and wiping in households',
                    ja: 'ホームデイリーでのクリーニングとワイプに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ShiCeZhiCeSuo.png'
            },
            {
                title: {
                    zh: '卫生清洁',
                    en: 'Office Use',
                    ja: 'オフィス使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '可用于个人卫生清洁',
                    en: 'Suitable for use in offices and conference rooms',
                    ja: 'オフィスや会議室などで使用に適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/ShiCeZhiQingJie.png'
            }
        ],
        relatedProducts: ['finishedpaper-019', 'finishedpaper-020', 'finishedpaper-022']
    },
    {
        id: 'finishedpaper-022',
        title: { zh: '竹纤维便携湿巾', en: 'Zhuyun 185 Soft Tissue', ja: 'ジュヨンイチハイロウルチョウ', Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ' },
        category: 'finishedpaper',
        desc: { zh: '富含竹纤维，深层清洁', en: 'Virgin bamboo pulp, green and healthy', ja: 'バージンバンブーパルプ、緑と健康です。' , Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ'},
        img: '/images/finishedPaper/ZhuXianWeiBianXieShiJinSuoLve.png',
        gallery: ['/images/finishedPaper/ZhuXianWeiBianXieShiJinSuoLve.png'],
        features: { zh: ['富含竹纤维','亲肤柔韧可降解','深层清洁','不含荧光、不含酒精'], en: ['Virgin bamboo pulp', 'Green and healthy'], ja: ['バージンバンブーパルプ', '緑と健康です。'], Russian: ['バージンバンブーパルプ', '緑と健康です。'], Malay: ['バージンバンブーパルプ', '緑と健康です。']  },
        certifications: [{icon:'fa-certificate',name:{zh:'ISO9001认证',en:'ISO9001 Certification',ja:'ISO9001認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-leaf',name:{zh:'FSC认证',en:'FSC Certification',ja:'FSC認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}}],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '白色',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '竹纤维',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '180mm x 180mm',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Layers',
                    ja: '層数',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '1层',
                    en: '3 layers',
                    ja: '3層',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '10片/包',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '竹纤维系列',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '深层清洁、可降解',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: 'GB/T27728',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '指导价',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '4元/包',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '商务接待',
                    en: 'Food Service',
                    ja: 'フードサービス',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适合商务接待等场所定制化使用',
                    en: 'Can be used in restaurants and cafes',
                    ja: 'レストランやカフェなどで使用できます',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/TiaoJinZhiShangWuHuiYi.png'
            },
            {
                title: {
                    zh: '出差便携',
                    en: 'Office Use',
                    ja: 'オフィス使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '可用于出差、机场高铁站等场所便携使用',
                    en: 'Suitable for use in offices and conference rooms',
                    ja: 'オフィスや会議室などで使用に適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/TiaoJinZhiChuChai.png'
            },
            {
                title: {
                    zh: '旅游便携',
                    en: 'Food Service',
                    ja: 'フードサービス',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适合旅游、露营等便携使用',
                    en: 'Can be used in restaurants and cafes',
                    ja: 'レストランやカフェなどで使用できます',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/TiaoJinZhiLuYou.png'
            }
        ],
        relatedProducts: ['finishedpaper-019', 'finishedpaper-020', 'finishedpaper-021']
    },
    {
        id: 'finishedpaper-023',
        title: { zh: '80抽竹浆乳霜柔润面纸', en: 'Zhuyun 185 Soft Tissue', ja: 'ジュヨンイチハイロウルチョウ', Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ' },
        category: 'finishedpaper',
        desc: { zh: '竹浆抑菌，至柔至润', en: 'Virgin bamboo pulp, green and healthy', ja: 'バージンバンブーパルプ、緑と健康です。' , Russian: 'バージンバンブーパルプ、緑と健康です。', Malay: 'バージンバンブーパルプ、緑と健康です。'},
        img: '/images/finishedPaper/ZhuJiangRuShuangRouRunMianZhi80Chou.png',
        gallery: ['/images/finishedPaper/ZhuJiangRuShuangRouRunMianZhi80Chou.png'],
        features: { zh: ['乳霜润肤、羽柔触感','竹浆抑菌','韧性结构，厚乘安心','擦拭无屑更安心'], en: ['Virgin bamboo pulp', 'Green and healthy'], ja: ['バージンバンブーパルプ', '緑と健康です。'], Russian: ['バージンバンブーパルプ', '緑と健康です。'], Malay: ['バージンバンブーパルプ', '緑と健康です。']  },
        certifications: [{icon:'fa-certificate',name:{zh:'ISO9001认证',en:'ISO9001 Certification',ja:'ISO9001認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-leaf',name:{zh:'FSC认证',en:'FSC Certification',ja:'FSC認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}}],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '白色',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '原生竹浆',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '170mm x 180mm',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Layers',
                    ja: '層数',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '5层',
                    en: '3 layers',
                    ja: '3層',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '80抽/包',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '乳霜纸系列',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '至柔至润、羽柔触感',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: 'GB/T 20808',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '指导价',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '10.99元/包',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '母婴适用',
                    en: 'Home Daily Use',
                    ja: 'ホームデイリー使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适用于母婴日常清洁、擦拭等用途',
                    en: 'Suitable for daily cleaning and wiping in households',
                    ja: 'ホームデイリーでのクリーニングとワイプに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/MuYing.png'
            },
            {
                title: {
                    zh: '敏感肌',
                    en: 'Home Daily Use',
                    ja: 'ホームデイリー使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适用于敏感肌人群日常清洁、擦拭等用途',
                    en: 'Suitable for daily cleaning and wiping in households',
                    ja: 'ホームデイリーでのクリーニングとワイプに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/MinGanJi.png'
            }
        ],
        relatedProducts: ['finishedpaper-024', 'finishedpaper-025', 'finishedpaper-019']
    },
    {
        id: 'finishedpaper-024',
        title: { zh: '30抽竹浆乳霜柔润面纸', en: 'Zhuyun 185 Soft Tissue', ja: 'ジュヨンイチハイロウルチョウ', Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ' },
        category: 'finishedpaper',
        desc: { zh: '竹浆抑菌，至柔至润', en: 'Virgin bamboo pulp, green and healthy', ja: 'バージンバンブーパルプ、緑と健康です。', Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ' },
        img: '/images/finishedPaper/ZhuJiangRuShuangRouRunMianZhi30ChouSuoLve.png',
        gallery: ['/images/finishedPaper/ZhuJiangRuShuangRouRunMianZhi30ChouSuoLve.png'],
        features: { zh: ['乳霜润肤、羽柔触感','竹浆抑菌','韧性结构，厚乘安心','轻巧一包，旅途的温柔陪伴'], en: ['Virgin bamboo pulp', 'Green and healthy'], ja: ['バージンバンブーパルプ', '緑と健康です。'], Russian: ['バージンバンブーパルプ', '緑と健康です。'], Malay: ['バージンバンブーパルプ', '緑と健康です。']  },
        certifications: [{icon:'fa-certificate',name:{zh:'ISO9001认证',en:'ISO9001 Certification',ja:'ISO9001認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-leaf',name:{zh:'FSC认证',en:'FSC Certification',ja:'FSC認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}}],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '白色',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '原生竹浆',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '138mm x 180mm',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Layers',
                    ja: '層数',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '5层',
                    en: '3 layers',
                    ja: '3層',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '30抽/包',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '乳霜纸系列',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '至柔至润、羽柔触感',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: 'GB/T 20808',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '指导价',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '4.99元/包',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '母婴适用',
                    en: 'Home Daily Use',
                    ja: 'ホームデイリー使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适用于母婴日常清洁、擦拭等用途',
                    en: 'Suitable for daily cleaning and wiping in households',
                    ja: 'ホームデイリーでのクリーニングとワイプに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/MuYing.png'
            },
            {
                title: {
                    zh: '敏感肌',
                    en: 'Home Daily Use',
                    ja: 'ホームデイリー使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适用于敏感肌人群日常清洁、擦拭等用途',
                    en: 'Suitable for daily cleaning and wiping in households',
                    ja: 'ホームデイリーでのクリーニングとワイプに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/MinGanJi.png'
            },
            {
                title: {
                    zh: '出差便携',
                    en: 'Office Use',
                    ja: 'オフィス使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '可用于出差、机场高铁站等场所便携使用',
                    en: 'Suitable for use in offices and conference rooms',
                    ja: 'オフィスや会議室などで使用に適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/TiaoJinZhiChuChai.png'
            }
        ],
        relatedProducts: ['finishedpaper-023', 'finishedpaper-025', 'finishedpaper-019']
    },
    {
        id: 'finishedpaper-025',
        title: { zh: '8片竹浆乳霜柔润面纸', en: 'Zhuyun 185 Soft Tissue', ja: 'ジュヨンイチハイロウルチョウ', Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ' },
        category: 'finishedpaper',
        desc: { zh: '竹浆抑菌，至柔至润', en: 'Virgin bamboo pulp, green and healthy', ja: 'バージンバンブーパルプ、緑と健康です。' , Russian: 'ジュヨンイチハイロウルチョウ', Malay: 'ジュヨンイチハイロウルチョウ'},
        img: '/images/finishedPaper/ZhuJiangRuShuangRouRunMianZhi8PianSuoLve.png',
        gallery: ['/images/finishedPaper/ZhuJiangRuShuangRouRunMianZhi8PianSuoLve.png'],
        features: { zh: ['乳霜润肤、羽柔触感','独立灭菌包装','韧性结构，厚乘安心','一抽即走，清爽随行'], en: ['Virgin bamboo pulp', 'Green and healthy'], ja: ['バージンバンブーパルプ', '緑と健康です。'], Russian: ['バージンバンブーパルプ', '緑と健康です。'], Malay: ['バージンバンブーパルプ', '緑と健康です。']  },
        certifications: [{icon:'fa-certificate',name:{zh:'ISO9001认证',en:'ISO9001 Certification',ja:'ISO9001認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}},{icon:'fa-leaf',name:{zh:'FSC认证',en:'FSC Certification',ja:'FSC認証',Russian:'ISO9001認証',Malay:'ISO9001認証'}}],
        specifications: [
            {
                name: {
                    zh: '颜色',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '白色',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '材质',
                    en: 'Weight',
                    ja: '重さ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '原生竹浆',
                    en: '18g/㎡',
                    ja: '18g/㎡',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '规格',
                    en: 'Specification',
                    ja: '仕様',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '200mm x 200mm',
                    en: '180mm x 180mm',
                    ja: '180mm x 180mm',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '层数',
                    en: 'Layers',
                    ja: '層数',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '5层',
                    en: '3 layers',
                    ja: '3層',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装规格',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '8片',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '包装',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '乳霜纸系列',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '功能',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '至柔至润、羽柔触感',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '执行标准',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: 'GB/T 20808',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            },
            {
                name: {
                    zh: '指导价',
                    en: 'Package Size',
                    ja: 'パッケージサイズ',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                value: {
                    zh: '2.09元/包',
                    en: '10 rolls/pack',
                    ja: '10巻/パック',
                    Russian: '仕様',
                    Malay: '仕様'
                }
            }
        ],
        usageExamples: [
            {
                title: {
                    zh: '母婴适用',
                    en: 'Home Daily Use',
                    ja: 'ホームデイリー使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适用于母婴日常清洁、擦拭等用途',
                    en: 'Suitable for daily cleaning and wiping in households',
                    ja: 'ホームデイリーでのクリーニングとワイプに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/MuYing.png'
            },
            {
                title: {
                    zh: '敏感肌',
                    en: 'Home Daily Use',
                    ja: 'ホームデイリー使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适用于敏感肌人群日常清洁、擦拭等用途',
                    en: 'Suitable for daily cleaning and wiping in households',
                    ja: 'ホームデイリーでのクリーニングとワイプに適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/MinGanJi.png'
            },
            {
                title: {
                    zh: '出差便携',
                    en: 'Office Use',
                    ja: 'オフィス使用',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '可用于出差、机场高铁站等场所便携使用',
                    en: 'Suitable for use in offices and conference rooms',
                    ja: 'オフィスや会議室などで使用に適しています',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/TiaoJinZhiChuChai.png'
            }
        ],
        relatedProducts: ['finishedpaper-023', 'finishedpaper-024', 'finishedpaper-019']
    },
    {
        id: 'fiber-001',
        title: { zh: '塑料级二醋酸纤维素', en: 'Plastic Grade Cellulose Diacetate', ja: 'プラスチックグレードセルローズジエタート', Russian: 'プラスチックグレードセルローズジエタート', Malay: 'プラスチックグレードセルローズジエタート' },
        category: 'fiber',
        desc: { zh: '优良的着色性能、加工性能，色泽亮丽', en: 'Excellent coloring and processing performance, bright color', ja: '優れた着色性能と加工性能、明るい色があります。', Russian: 'プラスチックグレードセルローズジエタート', Malay: 'プラスチックグレードセルローズジエタート' },
        img: '/images/Fibre/SuLiaoJiErCuSuanXianWeiSuSuoLve.png',
        gallery: ['/images/Fibre/SuLiaoJiErCuSuanXianWeiSuSuoLve.png'],
        features: { zh: ['优良的着色性能', '加工性能好，制品手感良好', '色泽亮丽'], en: ['Excellent coloring', 'Good processability', 'Bright color'], ja: ['優れた着色性能と加工性能', '明るい色があります。'], Russian: ['優れた着色性能と加工性能', '明るい色があります。'], Malay: ['優れた着色性能と加工性能', '明るい色があります。'] },
        certifications: [],
        specifications: [],
        usageExamples: [
            {
                title: {
                    zh: '高档眼镜、儿童玩具',
                    en: 'Food Service',
                    ja: 'フードサービス',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适合高档眼镜、儿童玩具等产品加工',
                    en: 'Can be used in restaurants and cafes',
                    ja: 'レストランやカフェなどで使用できます',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/CuSuanXianWeiYanJing.png'
            },
            {
                title: {
                    zh: '工具手柄',
                    en: 'Food Service',
                    ja: 'フードサービス',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适合工具手柄、工业按钮，汽车方向盘等产品加工',
                    en: 'Can be used in restaurants and cafes',
                    ja: 'レストランやカフェなどで使用できます',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/CuSuanXianWeiAnNiu.png'
            },
            {
                title: {
                    zh: '隐形胶带',
                    en: 'Food Service',
                    ja: 'フードサービス',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适合隐形胶带等产品加工',
                    en: 'Can be used in restaurants and cafes',
                    ja: 'レストランやカフェなどで使用できます',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/CuSuanXianWeiJiaoDai.png'
            }
        ],
        relatedProducts: ['fiber-002', 'fiber-003', 'cultural-003']
    },
    {
        id: 'fiber-002',
        title: { zh: '纺丝级二醋酸纤维素', en: 'Spinning Grade Cellulose Diacetate', ja: 'スピングレードセルローズジエタート', Russian: 'スピングレードセルローズジエタート', Malay: 'スピングレードセルローズジエタート' },
        category: 'fiber',
        desc: { zh: '吸附性好，染色后色泽鲜艳、日晒不掉色', en: 'Good adsorption, bright color after dyeing, colorfast to sunlight', ja: '良好な吸着性、染色後に明るい色があり、日光に晒されても色が落ちません。' , Russian: 'スピングレードセルローズジエタート', Malay: 'スピングレードセルローズジエタート'},
        img: '/images/Fibre/FangSiJiErCuSuanXianWeiSuSuoLve.png',
        gallery: ['/images/Fibre/FangSiJiErCuSuanXianWeiSuSuoLve.png'],
        features: { zh: ['吸附性好','长丝织品手感好' ,'染色后色泽鲜艳', '日晒不掉色'], en: ['Good adsorption', 'Bright color after dyeing', 'Sunlight colorfast'], ja: ['良好な吸着性、染色後に明るい色があり、日光に晒されても色が落ちません。'], Russian: ['良好な吸着性、染色後に明るい色があり、日光に晒されても色が落ちません。'], Malay: ['良好な吸着性、染色後に明るい色があり、日光に晒されても色が落ちません。'] },
        certifications: [],
        specifications: [],
        usageExamples: [
            {
                title: {
                    zh: '香烟过滤嘴',
                    en: 'Food Service',
                    ja: 'フードサービス',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适合香烟过滤嘴等产品加工',
                    en: 'Can be used in restaurants and cafes',
                    ja: 'レストランやカフェなどで使用できます',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/GuoLuZui.png'
            },
            {
                title: {
                    zh: '高档服装',
                    en: 'Food Service',
                    ja: 'フードサービス',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '与天然纤维、合成纤维混纺用于高档服装加工',
                    en: 'Can be used in restaurants and cafes',
                    ja: 'レストランやカフェなどで使用できます',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/CuSuanXianWeiGaoDangFuZhuang.png'
            }
        ],
        relatedProducts: ['fiber-001', 'fiber-003', 'cultural-003']
    },
    {
        id: 'fiber-003',
        title: { zh: '三醋酸纤维素', en: 'Cellulose Triacetate', ja: 'セルローズトリアセタート', Russian: 'セルローズトリアセタート', Malay: 'セルローズトリアセタート' },
        category: 'fiber',
        desc: { zh: '高耐磨性、高阻燃性、低雾度值和高透光率', en: 'High wear resistance, high flame retardancy, low haze, high light transmittance', ja: '高い耐摩耗性、高い阻燃性、低いハズレ値と高い光透過率があります。', Russian: '高い耐摩耗性、高い阻燃性、低いハズレ値と高い光透過率があります。', Malay: '高い耐摩耗性、高い阻燃性、低いハズレ値と高い光透過率があります。' },
        img: '/images/Fibre/SanCuSuanXianWeiSuSuoLve.png',
        gallery: ['/images/Fibre/SanCuSuanXianWeiSuSuoLve.png'],
        features: { zh: ['高耐磨性', '高阻燃性', '低雾度值', '高透光率'], en: ['High wear resistance', 'High flame retardancy', 'Low haze', 'High light transmittance'], ja: ['高い耐摩耗性、高い阻燃性、低いハズレ値と高い光透過率があります。'], Russian: ['高い耐摩耗性、高い阻燃性、低いハズレ値と高い光透過率があります。'], Malay: ['高い耐摩耗性、高い阻燃性、低いハズレ値と高い光透過率があります。'] },
        certifications: [],
        specifications: [],
        usageExamples: [
            {
                title: {
                    zh: '感光元件',
                    en: 'Food Service',
                    ja: 'フードサービス',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适用于感光胶片、显示器光学元件（如：液晶显示器偏振片（PVA膜）的保护膜）',
                    en: 'Can be used in restaurants and cafes',
                    ja: 'レストランやカフェなどで使用できます',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/CuSuanXianWeiGanGuangJiaoPian.png'
            },
            {
                title: {
                    zh: '眼镜片',
                    en: 'Food Service',
                    ja: 'フードサービス',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                desc: {
                    zh: '适用于眼镜片等产品加工',
                    en: 'Can be used in restaurants and cafes',
                    ja: 'レストランやカフェなどで使用できます',
                    Russian: '仕様',
                    Malay: '仕様'
                },
                img: '/images/ApplicationScenarios/YanJingPian.png'
            }
        ],
        relatedProducts: ['fiber-001', 'fiber-002', 'cultural-003']
    },
];

export const advantages: Advantage[] = [
    { 
        icon: 'fas fa-shield-alt', 
        title: {
            zh: '健康安全',
            en: 'Health & Safety',
            ja: '健康と安全',
            Russian: '仕様',
            Malay: '仕様'
        },
        desc: {
            zh: '竹浆纸天然抗菌，不添加荧光剂，对人体更加友好，特别适合婴幼儿和敏感肌肤使用。',
            en: 'Bamboo pulp paper is naturally antibacterial, free from fluorescent agents, making it more friendly to human body, especially suitable for infants and sensitive skin.',
            ja: 'バンブーパルプペーパーは天然抗菌であり、蛍光剤を添加していないため、人体にやさしく、特に乳幼児や敏感肌に適しています。',
            Russian: '仕様',
            Malay: '仕様'
        }
    },
    { 
        icon: 'fas fa-leaf', 
        title: {
            zh: '环保可持续',
            en: 'Eco-friendly & Sustainable',
            ja: 'エコフレンドリーでありがとう',
            Russian: '仕様',
            Malay: '仕様'
        },
        desc: {
            zh: '竹子生长周期短，3-5年可成熟，是可再生资源理想选择，生产过程减少对森林砍伐。',
            en: 'Bamboo has a short growth cycle of 3-5 years, making it an ideal renewable resource, reducing deforestation in the production process.',
            ja: 'バンブーは3-5年で成熟するため、再生可能なリソースとして理想的であり、生産プロセスで森林伐採を削減することができます。',
            Russian: '仕様',
            Malay: '仕様'
        }
    },
    { 
        icon: 'fas fa-tint', 
        title: {
            zh: '吸水性强',
            en: 'Strong Absorption',
            ja: '強い吸収力',
            Russian: '仕様',
            Malay: '仕様'
        },
        desc: {
            zh: '竹纤维多孔结构使得竹浆纸具有优异的吸水性能，吸水速度快，吸水量大。',
            en: 'The porous structure of bamboo fibers gives bamboo pulp paper excellent water absorption properties, with fast absorption speed and large absorption capacity.',
            ja: 'バンブーファイバーの多孔構造により、バンブーパルプペーパーは優れた水吸収特性を持ち、速く吸収し、大量の水を吸収することができます。',
            Russian: '仕様',
            Malay: '仕様'
        }
    },
    { 
        icon: 'fas fa-hand-paper', 
        title: {
            zh: '柔韧不易破',
            en: 'Flexible & Durable',
            ja: '柔らかで割れにくい',
            Russian: '仕様',
            Malay: '仕様'
        },
        desc: {
            zh: '竹纤维长度适中，纤维间结合紧密，制成的纸张韧性好，湿水不易破裂。',
            en: 'Bamboo fibers have moderate length and tight inter-fiber bonding, resulting in paper with good toughness that is not easily broken when wet.',
            ja: 'バンブーファイバーは適度の長さと緊密なファイバー間結合により、紙は湿ったときに割れにくく、強度があります。',
            Russian: '仕様',
            Malay: '仕様'
        }
    },
    { 
        icon: 'fas fa-sun', 
        title: {
            zh: '本色自然',
            en: 'Natural Color',
            ja: 'ナチュラルカラー',
            Russian: '仕様',
            Malay: '仕様'
        },
        desc: {
            zh: '采用本色工艺，保留竹子原有的颜色，减少漂白过程，更加环保健康。',
            en: 'Using natural color technology, preserving the original color of bamboo, reducing the bleaching process, making it more eco-friendly and healthy.',
            ja: '自然色技術を使用して、バンブーの元の色を維持し、漂白プロセスを削減することで、よりエコフレンドリーで健康的です。',
            Russian: '仕様',
            Malay: '仕様'
        }
    },
    { 
        icon: 'fas fa-recycle', 
        title: {
            zh: '可降解',
            en: 'Biodegradable',
            ja: 'エコフレンドリーでありがとう',
            Russian: '仕様',
            Malay: '仕様'
        },
        desc: {
            zh: '纯天然植物纤维，使用后可自然降解，不会产生环境污染，符合现代环保理念。',
            en: 'Pure natural plant fiber that can naturally degrade after use, causing no environmental pollution, in line with modern environmental protection concepts.',
            ja: '純粋な天然植物繊維で構成されているため、使用後に自然に分解され、環境汚染を引き起こすことはありません。現代の環境保護の概念に沿っています。',
            Russian: '仕様',
            Malay: '仕様'
        }
    },
];

export const applications: Application[] = [
    { 
        img: '/images/JiaTingShengHuoSuoLve.png', 
        title: {
            zh: '家庭生活',
            en: 'Home Life',
            ja: 'ホームライフ',
            Russian: '仕様',
            Malay: '仕様'
        },
        desc: {
            zh: '纸巾、卫生纸、厨房用纸等日常生活必需品，满足家庭清洁和个人卫生需求。',
            en: 'Tissue paper, toilet paper, kitchen paper and other daily necessities, meeting household cleaning and personal hygiene needs.',
            ja: 'トイレットペーパー、キッチンペーパーなどの日常的な必需品で、家庭の清潔と個人的なヒビキニューズを満たすことができます。',
            Russian: '仕様',
            Malay: '仕様'
        }
    },
    { 
        img: '/images/BanGongJiaoYuSuoLve.png', 
        title: {
            zh: '办公文教',
            en: 'Office & Education',
            ja: 'オフィス＆エデュケーション',
            Russian: '仕様',
            Malay: '仕様'
        },
        desc: {
            zh: '复印纸、笔记本、书写纸等办公和学习用品，提供优质的书写和打印体验。',
            en: 'Copy paper, notebooks, writing paper and other office and learning supplies, providing excellent writing and printing experience.',
            ja: 'コピーペーパー、ノート、書き込み用紙などのオフィスと教育に必要なものを提供し、優れた書き込みと印刷体験を提供します。',
            Russian: '仕様',
            Malay: '仕様'
        }
    },
    { 
        img: '/images/ShiPinBaoZhuangLingYuSuoLve.png', 
        title: {
            zh: '食品包装',
            en: 'Food Packaging',
            ja: 'フードパッケージ',
            Russian: '仕様',
            Malay: '仕様'
        },
        desc: {
            zh: '食品级包装纸、防油纸、餐巾纸等，确保食品安全和包装环保。',
            en: 'Food-grade packaging paper, oil-proof paper, napkins, etc., ensuring food safety and eco-friendly packaging.',
            ja: '食品レベルの包装紙、油切れ紙、ナポカンなどを使用して、食品の安全と環境に優しいパッケージを確保します。',
            Russian: '仕様',
            Malay: '仕様'
        }
    },
    { 
        img: '/images/YiLiaoWeiShengLingYuSuoLve.png', 
        title: {
            zh: '医疗卫生',
            en: 'Medical & Health',
            ja: '医療＆ヘルス',
            Russian: '仕様',
            Malay: '仕様'
        },
        desc: {
            zh: '医用擦拭纸、医疗包装纸等，满足医疗环境对清洁和卫生的严格要求。',
            en: 'Medical wipes, medical packaging paper, etc., meeting strict requirements for cleanliness and hygiene in medical environments.',
            ja: '医療環境での清潔とヒビキニューズを満たすために、医用のぬれ紙や医療用パッケージペーパーなどを使用します。',
            Russian: '仕様',
            Malay: '仕様'
        }
    },
    { 
        img: '/images/ShangWuDingZhiLingYuSuoLve.png', 
        title: {
            zh: '商务定制',
            en: 'Business Customization',
            ja: 'ビジネスカスタマイゼーション',
            Russian: '仕様',
            Malay: '仕様'
        },
        desc: {
            zh: '航空、高铁、商超等品牌产品定制加工和商务接待定制。',
            en: 'Custom processing for brand products in aviation, high-speed rail, supermarkets, and business reception customization.',
            ja: '航空、高速鉄道、スーパーなどのブランド製品のカスタマイゼーション加工とビジネスレシピゼーションを行います。',
            Russian: '仕様',
            Malay: '仕様'
        }
    },
    { 
        img: '/images/GongYeZhiZaoLingYuSuoLve.png', 
        title: {
            zh: '工业制造',
            en: 'Industrial Manufacturing',
            ja: 'インダストリアルマニュファクチャリング',
            Russian: '仕様',
            Malay: '仕様'
        },
        desc: {
            zh: '高档眼镜、天然纤维、感光材料、绝缘热压板等工业产品制造加工。',
            en: 'Manufacturing and processing of industrial products such as high-end glasses, natural fibers, photosensitive materials, and insulating hot-pressed boards.',
            ja: 'ハイエンドグラス、天然繊維、感光材料、絶縁ホットプレスボードなどの産業製品の製造と加工を行います。',
            Russian: '仕様',
            Malay: '仕様'
        }
    },
]; 